module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "appraisals-index"
    }
  }, [
    [(_vm.master_loading) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "view_spinner_container"
    }, [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)",
        "margin": "0 auto"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "4",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    })], 1), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Loading')) + "...")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "master_view"
    }, [_c('side-nav-bar', {
      attrs: {
        "filesOpen": _vm.filesOpen,
        "fileOpen": _vm.fileOpen,
        "fileId": _vm.appraisalfile.id,
        "fileNumber": _vm.appraisalfile.number,
        "reportOpen": _vm.reportOpen,
        "reportNumber": _vm.appraisalreport.number,
        "versionNumber": _vm.appraisalreport.version,
        "realEstates": _vm.appraisalreport_realestates,
        "realEstateId": _vm.realestate.id,
        "reportId": _vm.appraisalreport.id
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "app-container"
    }, [_c('bar'), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('Appraisal')) + " " + _vm._s(_vm.$t('of')) + " "), (_vm.appraisal.property_type) ? _c('span', [(_vm.currentLocale == 'ca') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_ca))]) : (_vm.currentLocale == 'en') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_en))]) : _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_es))])]) : _vm._e(), _vm._v(" " + _vm._s(_vm.$t('with')) + " " + _vm._s(_vm.$t('date')) + " " + _vm._s(_vm.appraisal.appraisaldate) + " " + _vm._s(_vm.$t('at')) + " "), (_vm.realestate.street_name) ? _c('span', [_vm._v(_vm._s(_vm.realestate.street_name))]) : _vm._e(), (_vm.realestate.street_number) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.street_number))]) : _vm._e(), (_vm.realestate.floor) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.floor))]) : _vm._e(), (_vm.realestate.door) ? _c('span', [_vm._v(" " + _vm._s(_vm.realestate.door))]) : _vm._e(), _vm._v(" "), (_vm.appraisal.dirty) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (_vm.appraisal.realestate_adopted_appraisal_method) ? _c('div', [(_vm.currentLocale == 'ca') ? _c('h2', [_vm._v(_vm._s(_vm.appraisal.realestate_adopted_appraisal_method.name_ca) + ": " + _vm._s(_vm._f("formatNumber")(_vm.appraisal.realestate_total_adopted_value)) + " €")]) : (_vm.currentLocale == 'en') ? _c('h2', [_vm._v(_vm._s(_vm.appraisal.realestate_adopted_appraisal_method.name_ca) + ": " + _vm._s(_vm._f("formatNumber")(_vm.appraisal.realestate_total_adopted_value)) + " €")]) : _c('h2', [_vm._v(_vm._s(_vm.appraisal.realestate_adopted_appraisal_method.name_es) + ": " + _vm._s(_vm._f("formatNumber")(_vm.appraisal.realestate_total_adopted_value)) + " €")])]) : _vm._e(), _vm._v(" "), (_vm.appraisal.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "datedata"
    }, [_c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Created')) + ": " + _vm._s(_vm.millis_to_time(_vm.appraisal.date_created)))]), _vm._v(" "), _c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Last_modified')) + ": " + _vm._s(_vm.millis_to_time(_vm.appraisal.date_modified)))])]), _vm._v(" "), _c('vue-tabs', {
      model: {
        value: (_vm.tabName),
        callback: function($$v) {
          _vm.tabName = $$v
        },
        expression: "tabName"
      }
    }, [_c('v-tab', {
      attrs: {
        "title": _vm.General_data_text
      }
    }, [(_vm.currentLocale === 'ca') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Dades generals')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.General_data_text) + "\n\t\t\t\t\t\t\t")]) : (_vm.currentLocale === 'en') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('General data')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.General_data_text) + "\n\t\t\t\t\t\t\t")]) : _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Datos generales')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.General_data_text))]), _vm._v(" "), _c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "form-section"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Elements_included_in_this_valuation')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Property_type')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.property_typeValue,
        "options": _vm.property_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_property_type
      },
      model: {
        value: (_vm.appraisal.property_type),
        callback: function($$v) {
          _vm.appraisal.property_type = $$v
        },
        expression: "appraisal.property_type"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Parking_spots_included_number')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.parking_spots_included_number),
        expression: "appraisal.parking_spots_included_number"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.parking_spots_included_number)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.parking_spots_included_number = $event.target.value
        }, _vm.set_appraisal_parking_spots_included_number],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Storage_room_included_in_appraisal')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.storage_room),
        expression: "appraisal.storage_room"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.storage_room) ? _vm._i(_vm.appraisal.storage_room, null) > -1 : (_vm.appraisal.storage_room)
      },
      on: {
        "click": _vm.set_appraisal_storage_room,
        "__c": function($event) {
          var $$a = _vm.appraisal.storage_room,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.storage_room = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.storage_room = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.storage_room = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Appraisal_type')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Appraisal_type')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.appraisalTypeValue,
        "options": _vm.appraisalTypeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ?
          'name_ca' : (_vm.currentLocale === 'en') ?
          'name_en' : 'name_es',
        "searchable": false
      },
      on: {
        "input": _vm.set_appraisal_type
      },
      model: {
        value: (_vm.appraisal.type),
        callback: function($$v) {
          _vm.appraisal.type = $$v
        },
        expression: "appraisal.type"
      }
    })], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "form-section"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Date')) + " " + _vm._s(_vm.$t('and')) + " " + _vm._s(_vm.$t('Appraisal_purpose')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Date_of_the_appraisal_value')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.appraisaldate),
        expression: "appraisal.appraisaldate"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "date",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.appraisaldate)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.appraisaldate = $event.target.value
        }, _vm.set_appraisal_appraisaldate]
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Appraisal_purpose')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.appraisalPurposeValue,
        "options": _vm.appraisalPurposeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ?
          'name_ca' : (_vm.currentLocale === 'en') ?
          'name_en' : 'name_es',
        "searchable": false
      },
      on: {
        "input": _vm.set_appraisal_purpose
      },
      model: {
        value: (_vm.appraisal.purpose),
        callback: function($$v) {
          _vm.appraisal.purpose = $$v
        },
        expression: "appraisal.purpose"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Market_value_adjustment_pct')) + " (%)")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.reduction_pct),
        expression: "appraisal.reduction_pct"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.reduction_pct)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.reduction_pct = $event.target.value
        }, _vm.set_appraisal_reduction_pct],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), (_vm.loadingAppraisalPurpose) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "1",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Loading')) + "...")], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Notes'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.purpose_notes),
        expression: "appraisal.purpose_notes"
      }],
      staticClass: "field__group__textarea",
      attrs: {
        "rows": "5",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.purpose_notes)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.purpose_notes = $event.target.value
        }, _vm.set_appraisal_purpose_notes]
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Visit')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Visit_date'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.visitdate),
        expression: "appraisal.visitdate"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "date",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.visitdate)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.visitdate = $event.target.value
        }, _vm.set_appraisal_visitdate]
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Technician_who_performed_the_visit'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.technician_visitingValue,
        "options": _vm.object_to_array(_vm.appraisers),
        "track-by": "id",
        "label": 'complete_name',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_technician_visiting
      },
      model: {
        value: (_vm.appraisal.technician_visiting),
        callback: function($$v) {
          _vm.appraisal.technician_visiting = $$v
        },
        expression: "appraisal.technician_visiting"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Cadastral_data')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Cadastral_reference')))]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.realestate.cadastral_reference) + " ")])]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('button', {
      staticClass: "quote-request__aux__button",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onOpenCadastralFile($event)
        },
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          _vm.onOpenCadastralFile($event)
        }
      }
    }, [_c('span', [_c('icon', {
      attrs: {
        "name": "external-link",
        "scale": "1",
        "color": "rgb(0, 79, 146)"
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Open')) + " " + _vm._s(_vm.$t('Cadastral_file')))], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Construction_year')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.cadastral_construction_year),
        expression: "appraisal.cadastral_construction_year"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.cadastral_construction_year)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.cadastral_construction_year = $event.target.value
        }, _vm.set_appraisal_cadastral_construction_year],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Usage')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.cadastral_usage),
        expression: "appraisal.cadastral_usage"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.cadastral_usage)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.cadastral_usage = $event.target.value
        }, _vm.set_appraisal_cadastral_usage]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Floor')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.cadastral_floor),
        expression: "appraisal.cadastral_floor"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.cadastral_floor)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.cadastral_floor = $event.target.value
        }, _vm.set_appraisal_cadastral_floor]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Door')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.cadastral_door),
        expression: "appraisal.cadastral_door"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.cadastral_door)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.cadastral_door = $event.target.value
        }, _vm.set_appraisal_cadastral_door]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Block')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.cadastral_block),
        expression: "appraisal.cadastral_block"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.cadastral_block)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.cadastral_block = $event.target.value
        }, _vm.set_appraisal_cadastral_block]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Staircase')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.cadastral_staircase),
        expression: "appraisal.cadastral_staircase"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.cadastral_staircase)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.cadastral_staircase = $event.target.value
        }, _vm.set_appraisal_cadastral_staircase]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Built_area')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.built_cadastral_area),
        expression: "appraisal.built_cadastral_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.built_cadastral_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.built_cadastral_area = $event.target.value
        }, _vm.set_appraisal_built_cadastral_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Common_elements_cadastral_area')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.common_elements_cadastral_area),
        expression: "appraisal.common_elements_cadastral_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.common_elements_cadastral_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.common_elements_cadastral_area = $event.target.value
        }, _vm.set_appraisal_common_elements_cadastral_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Built_plus_common_elements_area')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.built_plus_common_elements_cadastral_area),
        expression: "appraisal.built_plus_common_elements_cadastral_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.built_plus_common_elements_cadastral_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.built_plus_common_elements_cadastral_area = $event.target.value
        }, _vm.set_appraisal_built_plus_common_elements_cadastral_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Registry_data')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Registry')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.registry_name),
        expression: "appraisal.registry_name"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.registry_name)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.registry_name = $event.target.value
        }, _vm.set_appraisal_registry_name]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Section')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.registry_section),
        expression: "appraisal.registry_section"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.registry_section)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.registry_section = $event.target.value
        }, _vm.set_appraisal_registry_section]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Volume')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.registry_volume),
        expression: "appraisal.registry_volume"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.registry_volume)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.registry_volume = $event.target.value
        }, _vm.set_appraisal_registry_volume]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Book')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.registry_book),
        expression: "appraisal.registry_book"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.registry_book)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.registry_book = $event.target.value
        }, _vm.set_appraisal_registry_book]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Page')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.registry_page),
        expression: "appraisal.registry_page"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.registry_page)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.registry_page = $event.target.value
        }, _vm.set_appraisal_registry_page]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Registry_real_estate_number')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.registry_real_estate_number),
        expression: "appraisal.registry_real_estate_number"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.registry_real_estate_number)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.registry_real_estate_number = $event.target.value
        }, _vm.set_appraisal_registry_real_estate_number]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v("IDUFIR")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.registry_idufir),
        expression: "appraisal.registry_idufir"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.registry_idufir)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.registry_idufir = $event.target.value
        }, _vm.set_appraisal_registry_idufir]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Holder')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.registry_owner),
        expression: "appraisal.registry_owner"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.registry_owner)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.registry_owner = $event.target.value
        }, _vm.set_appraisal_registry_owner]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Property_coef')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.registry_property_coef),
        expression: "appraisal.registry_property_coef"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.registry_property_coef)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.registry_property_coef = $event.target.value
        }, _vm.set_appraisal_registry_property_coef],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Net_area')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.net_registry_area),
        expression: "appraisal.net_registry_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.net_registry_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.net_registry_area = $event.target.value
        }, _vm.set_appraisal_net_registry_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Enclosed_area')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.enclosed_registry_area),
        expression: "appraisal.enclosed_registry_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.enclosed_registry_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.enclosed_registry_area = $event.target.value
        }, _vm.set_appraisal_enclosed_registry_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Covered_outdoors_area')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.covered_terraces_total_registry_area),
        expression: "appraisal.covered_terraces_total_registry_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.covered_terraces_total_registry_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.covered_terraces_total_registry_area = $event.target.value
        }, _vm.set_appraisal_covered_terraces_total_registry_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Uncovered_outdoors_area')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.uncovered_terraces_total_registry_area),
        expression: "appraisal.uncovered_terraces_total_registry_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.uncovered_terraces_total_registry_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.uncovered_terraces_total_registry_area = $event.target.value
        }, _vm.set_appraisal_uncovered_terraces_total_registry_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Built_area')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.built_registry_area),
        expression: "appraisal.built_registry_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.built_registry_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.built_registry_area = $event.target.value
        }, _vm.set_appraisal_built_registry_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Built_plus_common_elements_area')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.built_plus_common_elements_registry_area),
        expression: "appraisal.built_plus_common_elements_registry_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.built_plus_common_elements_registry_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.built_plus_common_elements_registry_area = $event.target.value
        }, _vm.set_appraisal_built_plus_common_elements_registry_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])])])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.urban_and_surroundings_text
      }
    }, [(_vm.currentLocale === 'ca') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Urbanisme i entorn')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.urban_and_surroundings_text) + "\n\t\t\t\t\t\t\t")]) : (_vm.currentLocale === 'en') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Urban planning and surroundings')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.urban_and_surroundings_text) + "\n\t\t\t\t\t\t\t")]) : _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Urbanismo y entorno')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.urban_and_surroundings_text))]), _vm._v(" "), _c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "form-section"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Urban_planning_parameters')))]), _vm._v(" "), (_vm.muc_info_loading) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "1",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Loading')) + "...")], 1)]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-right": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onRequestMucInfo($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "globe",
        "text": "MUC Info",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Plan_type'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.urban_planning_type),
        expression: "appraisal.urban_planning_type"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.urban_planning_type)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.urban_planning_type = $event.target.value
        }, _vm.set_appraisal_urban_planning_type]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('File'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.urban_planning_file),
        expression: "appraisal.urban_planning_file"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.urban_planning_file)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.urban_planning_file = $event.target.value
        }, _vm.set_appraisal_urban_planning_file]
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Council_qualification'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.urban_planning_council_qualification),
        expression: "appraisal.urban_planning_council_qualification"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.urban_planning_council_qualification)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.urban_planning_council_qualification = $event.target.value
        }, _vm.set_appraisal_urban_planning_council_qualification]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Council_qualification_description'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.urban_planning_council_qualification_description),
        expression: "appraisal.urban_planning_council_qualification_description"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.urban_planning_council_qualification_description)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.urban_planning_council_qualification_description = $event.target.value
        }, _vm.set_appraisal_urban_planning_council_qualification_description]
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Council_classification'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.urban_planning_council_classification),
        expression: "appraisal.urban_planning_council_classification"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.urban_planning_council_classification)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.urban_planning_council_classification = $event.target.value
        }, _vm.set_appraisal_urban_planning_council_classification]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Council_classification_description'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.urban_planning_council_classification_description),
        expression: "appraisal.urban_planning_council_classification_description"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.urban_planning_council_classification_description)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.urban_planning_council_classification_description = $event.target.value
        }, _vm.set_appraisal_urban_planning_council_classification_description]
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Regional_qualification'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.urban_planning_regional_qualification),
        expression: "appraisal.urban_planning_regional_qualification"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.urban_planning_regional_qualification)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.urban_planning_regional_qualification = $event.target.value
        }, _vm.set_appraisal_urban_planning_regional_qualification]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Regional_qualification_description'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.urban_planning_regional_qualification_description),
        expression: "appraisal.urban_planning_regional_qualification_description"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.urban_planning_regional_qualification_description)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.urban_planning_regional_qualification_description = $event.target.value
        }, _vm.set_appraisal_urban_planning_regional_qualification_description]
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Regional_classification'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.urban_planning_regional_classification),
        expression: "appraisal.urban_planning_regional_classification"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.urban_planning_regional_classification)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.urban_planning_regional_classification = $event.target.value
        }, _vm.set_appraisal_urban_planning_regional_classification]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Regional_classification_description'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.urban_planning_regional_classification_description),
        expression: "appraisal.urban_planning_regional_classification_description"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.urban_planning_regional_classification_description)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.urban_planning_regional_classification_description = $event.target.value
        }, _vm.set_appraisal_urban_planning_regional_classification_description]
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "form-section"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('MUC_map')))]), _vm._v(" "), (_vm.muc_map_01_loading) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "1",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Loading')) + " Map 01...")], 1)]) : _vm._e(), _vm._v(" "), (_vm.muc_map_02_loading) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "1",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Loading')) + " Map 02...")], 1)]) : _vm._e(), _vm._v(" "), (_vm.muc_map_03_loading) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "1",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Loading')) + " Map 03...")], 1)]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-right": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onRequestMucMap($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "globe",
        "text": "Mapa del MUC",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "field-container",
      staticStyle: {
        "justify-content": "baseline!important"
      }
    }, [(_vm.appraisal.map_urban_muc_land_colors) ? _c('div', [_c('div', {
      staticStyle: {
        "background": "transparent",
        "padding": "2em",
        "border": "1px solid lightgray",
        "margin": "2em",
        "box-shadow": "0 2px 4px rgba(0, 0, 0, 0.04)"
      }
    }, [_c('div', {
      staticStyle: {
        "text-align": "center",
        "padding-bottom": "1em"
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('Map')) + " 1/3")])]), _vm._v(" "), _c('div', [_c('img', {
      attrs: {
        "src": _vm.appraisal.map_urban_muc_land_colors,
        "width": "640px",
        "height": "480px"
      }
    })]), _vm._v(" "), _c('div', [_c('table', {
      staticStyle: {
        "width": "640px",
        "text-align": "center"
      }
    }, [_c('tr', [_c('td', [_c('table', {
      staticStyle: {
        "width": "240px",
        "text-align": "center",
        "margin": "0 auto"
      }
    }, [_c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    })]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "center!important"
      },
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoUpMapUrbanMuc($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "arrow-up",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoLeftMapUrbanMuc($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "arrow-left",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)]), _vm._v(" "), _c('td', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoRightMapUrbanMuc($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "arrow-right",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "center!important"
      },
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoDownMapUrbanMuc($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "arrow-down",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)])])])]), _vm._v(" "), _c('td', [_c('table', {
      staticStyle: {
        "width": "240px",
        "text-align": "center",
        "margin": "0 auto"
      }
    }, [_c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('span', {
      staticClass: "small"
    }, [_vm._v("zoom: " + _vm._s(_vm.appraisal.map_urban_muc_land_colors_zoom))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onDecreaseZoomMapUrbanMuc($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "minus",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)]), _vm._v(" "), _c('td', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onIncreaseZoomMapUrbanMuc($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)])])])])])])])]), _vm._v(" "), _c('div')]) : _vm._e(), _vm._v(" "), (_vm.appraisal.map_urban_muc_council_qual) ? _c('div', [_c('div', {
      staticStyle: {
        "background": "transparent",
        "padding": "2em",
        "border": "1px solid lightgray",
        "margin": "2em",
        "box-shadow": "0 2px 4px rgba(0, 0, 0, 0.04)"
      }
    }, [_c('div', {
      staticStyle: {
        "text-align": "center",
        "padding-bottom": "1em"
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('Map')) + " 2/3")])]), _vm._v(" "), _c('div', [_c('img', {
      attrs: {
        "src": _vm.appraisal.map_urban_muc_council_qual,
        "width": "640px",
        "height": "480px"
      }
    })]), _vm._v(" "), _c('div', [_c('table', {
      staticStyle: {
        "width": "640px",
        "text-align": "center"
      }
    }, [_c('tr', [_c('td', [_c('table', {
      staticStyle: {
        "width": "240px",
        "text-align": "center",
        "margin": "0 auto"
      }
    }, [_c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    })]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "center!important"
      },
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoUpMapUrbanMuc($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "arrow-up",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoLeftMapUrbanMuc($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "arrow-left",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)]), _vm._v(" "), _c('td', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoRightMapUrbanMuc($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "arrow-right",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "center!important"
      },
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoDownMapUrbanMuc($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "arrow-down",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)])])])]), _vm._v(" "), _c('td', [_c('table', {
      staticStyle: {
        "width": "240px",
        "text-align": "center",
        "margin": "0 auto"
      }
    }, [_c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('span', {
      staticClass: "small"
    }, [_vm._v("zoom: " + _vm._s(_vm.appraisal.map_urban_muc_council_qual_zoom))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onDecreaseZoomMapUrbanMuc($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "minus",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)]), _vm._v(" "), _c('td', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onIncreaseZoomMapUrbanMuc($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)])])])])])])])]), _vm._v(" "), _c('div')]) : _vm._e(), _vm._v(" "), (_vm.appraisal.map_urban_icc_topo) ? _c('div', [_c('div', {
      staticStyle: {
        "background": "transparent",
        "padding": "2em",
        "border": "1px solid lightgray",
        "margin": "2em",
        "box-shadow": "0 2px 4px rgba(0, 0, 0, 0.04)"
      }
    }, [_c('div', {
      staticStyle: {
        "text-align": "center",
        "padding-bottom": "1em"
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('Map')) + " 3/3")])]), _vm._v(" "), _c('div', [_c('img', {
      attrs: {
        "src": _vm.appraisal.map_urban_icc_topo,
        "width": "640px",
        "height": "480px"
      }
    })]), _vm._v(" "), _c('div', [_c('table', {
      staticStyle: {
        "width": "640px",
        "text-align": "center"
      }
    }, [_c('tr', [_c('td', [_c('table', {
      staticStyle: {
        "width": "240px",
        "text-align": "center",
        "margin": "0 auto"
      }
    }, [_c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    })]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "center!important"
      },
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoUpMapUrbanMuc($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "arrow-up",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoLeftMapUrbanMuc($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "arrow-left",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)]), _vm._v(" "), _c('td', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoRightMapUrbanMuc($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "arrow-right",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "center!important"
      },
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoDownMapUrbanMuc($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "arrow-down",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)])])])]), _vm._v(" "), _c('td', [_c('table', {
      staticStyle: {
        "width": "240px",
        "text-align": "center",
        "margin": "0 auto"
      }
    }, [_c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('span', {
      staticClass: "small"
    }, [_vm._v("zoom: " + _vm._s(_vm.appraisal.map_urban_icc_topo_zoom))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onDecreaseZoomMapUrbanMuc($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "minus",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)]), _vm._v(" "), _c('td', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onIncreaseZoomMapUrbanMuc($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)])])])])])])])]), _vm._v(" "), _c('div')]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "form-section"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Locality')))]), _vm._v(" "), (_vm.idescat_info_loading) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "1",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Loading')) + "...")], 1)]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-right": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onRequestIdescatInfoByCodeIne($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "globe",
        "text": "Idescat Info",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Nucleus_area')) + " (km²)")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.nucleus_area),
        expression: "appraisal.nucleus_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.nucleus_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.nucleus_area = $event.target.value
        }, _vm.set_appraisal_nucleus_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Population')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.nucleus_population),
        expression: "appraisal.nucleus_population"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.nucleus_population)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.nucleus_population = $event.target.value
        }, _vm.set_appraisal_nucleus_population],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Population_density')) + " (hab/km²)")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.nucleus_population_density),
        expression: "appraisal.nucleus_population_density"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.nucleus_population_density)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.nucleus_population_density = $event.target.value
        }, _vm.set_appraisal_nucleus_population_density],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Population_growth')) + " (" + _vm._s(_vm.$t('Gross_tax_per_1000_inhabitants')) + ")")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.nucleus_population_growth),
        expression: "appraisal.nucleus_population_growth"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.nucleus_population_growth)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.nucleus_population_growth = $event.target.value
        }, _vm.set_appraisal_nucleus_population_growth],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Nucleus_type')))]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.nucleus_type),
        expression: "appraisal.nucleus_type"
      }],
      staticClass: "field__group__textarea",
      attrs: {
        "rows": "2",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.nucleus_type)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.nucleus_type = $event.target.value
        }, _vm.set_appraisal_nucleus_type]
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Employment_occupation')))]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.occupation_description),
        expression: "appraisal.occupation_description"
      }],
      staticClass: "field__group__textarea",
      attrs: {
        "rows": "3",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.occupation_description)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.occupation_description = $event.target.value
        }, _vm.set_appraisal_occupation_description]
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Surroundings')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('table', [_c('tr', [_c('td', [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Territorial_feature'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.surrounding_territorial_featureValue,
        "options": _vm.territorial_featureOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_surrounding_territorial_feature
      },
      model: {
        value: (_vm.appraisal.surrounding_territorial_feature),
        callback: function($$v) {
          _vm.appraisal.surrounding_territorial_feature = $$v
        },
        expression: "appraisal.surrounding_territorial_feature"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Income_level'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.surrounding_income_levelValue,
        "options": _vm.quality_levelOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_surrounding_income_level
      },
      model: {
        value: (_vm.appraisal.surrounding_income_level),
        callback: function($$v) {
          _vm.appraisal.surrounding_income_level = $$v
        },
        expression: "appraisal.surrounding_income_level"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Homogeneity_feature'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.surrounding_homogeneity_featureValue,
        "options": _vm.homogeneity_featureOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_surrounding_homogeneity_feature
      },
      model: {
        value: (_vm.appraisal.surrounding_homogeneity_feature),
        callback: function($$v) {
          _vm.appraisal.surrounding_homogeneity_feature = $$v
        },
        expression: "appraisal.surrounding_homogeneity_feature"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Main_uses'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.surrounding_main_usesValue,
        "options": _vm.usage_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_surrounding_main_uses
      },
      model: {
        value: (_vm.appraisal.surrounding_main_uses),
        callback: function($$v) {
          _vm.appraisal.surrounding_main_uses = $$v
        },
        expression: "appraisal.surrounding_main_uses"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Density'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.surrounding_densityValue,
        "options": _vm.quality_levelOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_surrounding_density
      },
      model: {
        value: (_vm.appraisal.surrounding_density),
        callback: function($$v) {
          _vm.appraisal.surrounding_density = $$v
        },
        expression: "appraisal.surrounding_density"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Accessibility'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.surrounding_accessibilityValue,
        "options": _vm.accessibility_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_surrounding_accessibility
      },
      model: {
        value: (_vm.appraisal.surrounding_accessibility),
        callback: function($$v) {
          _vm.appraisal.surrounding_accessibility = $$v
        },
        expression: "appraisal.surrounding_accessibility"
      }
    })], 1)])])])])]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('Building_development_level')))]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('div', {
      staticClass: "field-container"
    }, [_c('table', [_c('tr', [_c('td', [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Consolidation_degree'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.surrounding_consolidation_degreeValue,
        "options": _vm.degree_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_surrounding_consolidation_degree
      },
      model: {
        value: (_vm.appraisal.surrounding_consolidation_degree),
        callback: function($$v) {
          _vm.appraisal.surrounding_consolidation_degree = $$v
        },
        expression: "appraisal.surrounding_consolidation_degree"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Occupation_degree'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.surrounding_occupation_degreeValue,
        "options": _vm.degree_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_surrounding_occupation_degree
      },
      model: {
        value: (_vm.appraisal.surrounding_occupation_degree),
        callback: function($$v) {
          _vm.appraisal.surrounding_occupation_degree = $$v
        },
        expression: "appraisal.surrounding_occupation_degree"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Evolution'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.surrounding_evolution_speedValue,
        "options": _vm.evolution_speedOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_surrounding_evolution_speed
      },
      model: {
        value: (_vm.appraisal.surrounding_evolution_speed),
        callback: function($$v) {
          _vm.appraisal.surrounding_evolution_speed = $$v
        },
        expression: "appraisal.surrounding_evolution_speed"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Average_age'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.surrounding_average_ageValue,
        "options": _vm.average_ageOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_surrounding_average_age
      },
      model: {
        value: (_vm.appraisal.surrounding_average_age),
        callback: function($$v) {
          _vm.appraisal.surrounding_average_age = $$v
        },
        expression: "appraisal.surrounding_average_age"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Conservation_status'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.surrounding_conservation_statusValue,
        "options": _vm.conservation_statusOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_surrounding_conservation_status
      },
      model: {
        value: (_vm.appraisal.surrounding_conservation_status),
        callback: function($$v) {
          _vm.appraisal.surrounding_conservation_status = $$v
        },
        expression: "appraisal.surrounding_conservation_status"
      }
    })], 1)])])])])]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('Facilities')))]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('div', {
      staticClass: "field-container"
    }, [_c('table', [_c('tr', [_c('td', [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Commercial'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.surrounding_commercial_facilitiesValue,
        "options": _vm.levelOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_surrounding_commercial_facilities
      },
      model: {
        value: (_vm.appraisal.surrounding_commercial_facilities),
        callback: function($$v) {
          _vm.appraisal.surrounding_commercial_facilities = $$v
        },
        expression: "appraisal.surrounding_commercial_facilities"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Educational'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.surrounding_educational_facilitiesValue,
        "options": _vm.levelOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_surrounding_educational_facilities
      },
      model: {
        value: (_vm.appraisal.surrounding_educational_facilities),
        callback: function($$v) {
          _vm.appraisal.surrounding_educational_facilities = $$v
        },
        expression: "appraisal.surrounding_educational_facilities"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Public_parking'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.surrounding_public_parkingValue,
        "options": _vm.levelOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_surrounding_public_parking
      },
      model: {
        value: (_vm.appraisal.surrounding_public_parking),
        callback: function($$v) {
          _vm.appraisal.surrounding_public_parking = $$v
        },
        expression: "appraisal.surrounding_public_parking"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Medical_assistance'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.surrounding_medical_assistanceValue,
        "options": _vm.levelOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_surrounding_medical_assistance
      },
      model: {
        value: (_vm.appraisal.surrounding_medical_assistance),
        callback: function($$v) {
          _vm.appraisal.surrounding_medical_assistance = $$v
        },
        expression: "appraisal.surrounding_medical_assistance"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Leisure'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.surrounding_leisureValue,
        "options": _vm.levelOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_surrounding_leisure
      },
      model: {
        value: (_vm.appraisal.surrounding_leisure),
        callback: function($$v) {
          _vm.appraisal.surrounding_leisure = $$v
        },
        expression: "appraisal.surrounding_leisure"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Notes'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.surrounding_facilities_notes),
        expression: "appraisal.surrounding_facilities_notes"
      }],
      staticClass: "field__group__textarea",
      attrs: {
        "rows": "3",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.surrounding_facilities_notes)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.surrounding_facilities_notes = $event.target.value
        }, _vm.set_appraisal_surrounding_facilities_notes]
      }
    })])])])])])])]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('Communications')))]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('div', {
      staticClass: "field-container"
    }, [_c('table', [_c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Airport'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.communications_airport),
        expression: "appraisal.communications_airport"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.communications_airport)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.communications_airport = $event.target.value
        }, _vm.set_appraisal_communications_airport]
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Harbour'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.communications_harbour),
        expression: "appraisal.communications_harbour"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.communications_harbour)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.communications_harbour = $event.target.value
        }, _vm.set_appraisal_communications_harbour]
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Train'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.communications_train),
        expression: "appraisal.communications_train"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.communications_train)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.communications_train = $event.target.value
        }, _vm.set_appraisal_communications_train]
      }
    })])])])])]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('Public_transport')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('table', [_c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Urban_underground'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.public_transport_urban_underground),
        expression: "appraisal.public_transport_urban_underground"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.public_transport_urban_underground)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.public_transport_urban_underground = $event.target.value
        }, _vm.set_appraisal_public_transport_urban_underground]
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Interurban'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.public_transport_interurban),
        expression: "appraisal.public_transport_interurban"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.public_transport_interurban)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.public_transport_interurban = $event.target.value
        }, _vm.set_appraisal_public_transport_interurban]
      }
    })])])])])])])])])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.land_text
      }
    }, [(_vm.currentLocale === 'ca') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Terreny')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.land_text) + "\n\t\t\t\t\t\t\t")]) : (_vm.currentLocale === 'en') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Terrain')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.land_text) + "\n\t\t\t\t\t\t\t")]) : _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Terreno')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.land_text))]), _vm._v(" "), _c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form",
      attrs: {
        "action": ""
      }
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Plot_area')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('table', {
      staticStyle: {
        "width": "40em"
      }
    }, [_c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Registry_area')) + " (m²)"), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.land_registry_area),
        expression: "appraisal.land_registry_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.land_registry_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.land_registry_area = $event.target.value
        }, _vm.set_appraisal_land_registry_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Cadastral_area')) + " (m²)"), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.land_cadastral_area),
        expression: "appraisal.land_cadastral_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.land_cadastral_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.land_cadastral_area = $event.target.value
        }, _vm.set_appraisal_land_cadastral_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Checked_area')) + " (m²)"), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.land_checked_area),
        expression: "appraisal.land_checked_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.land_checked_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.land_checked_area = $event.target.value
        }, _vm.set_appraisal_land_checked_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Land_selected_area')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.land_selected_areaValue,
        "options": _vm.selected_areaOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_land_selected_area
      },
      model: {
        value: (_vm.appraisal.land_selected_area),
        callback: function($$v) {
          _vm.appraisal.land_selected_area = $$v
        },
        expression: "appraisal.land_selected_area"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Adopted_area')) + " (m²)"), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.land_adopted_area),
        expression: "appraisal.land_adopted_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.land_adopted_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.land_adopted_area = $event.target.value
        }, _vm.set_appraisal_land_adopted_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Notes_on_plot_area')) + " "), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.land_area_notes),
        expression: "appraisal.land_area_notes"
      }],
      staticClass: "field__group__textarea",
      attrs: {
        "rows": "5",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.land_area_notes)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.land_area_notes = $event.target.value
        }, _vm.set_appraisal_land_area_notes]
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Land_is_plot_according_to_law')) + " "), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.land_is_plot_according_to_law),
        expression: "appraisal.land_is_plot_according_to_law"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.land_is_plot_according_to_law) ? _vm._i(_vm.appraisal.land_is_plot_according_to_law, null) > -1 : (_vm.appraisal.land_is_plot_according_to_law)
      },
      on: {
        "input": _vm.set_appraisal_land_is_plot_according_to_law,
        "__c": function($event) {
          var $$a = _vm.appraisal.land_is_plot_according_to_law,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.land_is_plot_according_to_law = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.land_is_plot_according_to_law = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.land_is_plot_according_to_law = $$c
          }
        }
      }
    })])])])])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Plot_occupation')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Plot_occupation')) + " "), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.plot_occupationValue,
        "options": _vm.plot_occupationOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_plot_occupation
      },
      model: {
        value: (_vm.appraisal.plot_occupation),
        callback: function($$v) {
          _vm.appraisal.plot_occupation = $$v
        },
        expression: "appraisal.plot_occupation"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Plot_free_area_usage')) + " "), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.plot_free_area_usageValue,
        "options": _vm.plot_free_area_usageOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_plot_free_area_usage
      },
      model: {
        value: (_vm.appraisal.plot_free_area_usage),
        callback: function($$v) {
          _vm.appraisal.plot_free_area_usage = $$v
        },
        expression: "appraisal.plot_free_area_usage"
      }
    })], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Infrastructures')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('table', {
      staticStyle: {
        "width": "60em"
      }
    }, [_c('tr', [_c('td', {
      staticStyle: {
        "width": "20em"
      }
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Paving')) + " "), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.land_infrastructure_paving),
        expression: "appraisal.land_infrastructure_paving"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.land_infrastructure_paving) ? _vm._i(_vm.appraisal.land_infrastructure_paving, null) > -1 : (_vm.appraisal.land_infrastructure_paving)
      },
      on: {
        "click": _vm.set_appraisal_land_infrastructure_paving,
        "__c": function($event) {
          var $$a = _vm.appraisal.land_infrastructure_paving,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.land_infrastructure_paving = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.land_infrastructure_paving = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.land_infrastructure_paving = $$c
          }
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Paving_execution_pct')) + " (%)"), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.land_infrastructure_paving_execution_pct),
        expression: "appraisal.land_infrastructure_paving_execution_pct"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.land_infrastructure_paving_execution_pct)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.land_infrastructure_paving_execution_pct = $event.target.value
        }, _vm.set_appraisal_land_infrastructure_paving_execution_pct],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Sewage')) + " "), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.land_infrastructure_sewage),
        expression: "appraisal.land_infrastructure_sewage"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.land_infrastructure_sewage) ? _vm._i(_vm.appraisal.land_infrastructure_sewage, null) > -1 : (_vm.appraisal.land_infrastructure_sewage)
      },
      on: {
        "click": _vm.set_appraisal_land_infrastructure_sewage,
        "__c": function($event) {
          var $$a = _vm.appraisal.land_infrastructure_sewage,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.land_infrastructure_sewage = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.land_infrastructure_sewage = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.land_infrastructure_sewage = $$c
          }
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Sewage_execution_pct')) + " (%)"), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.land_infrastructure_sewage_execution_pct),
        expression: "appraisal.land_infrastructure_sewage_execution_pct"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.land_infrastructure_sewage_execution_pct)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.land_infrastructure_sewage_execution_pct = $event.target.value
        }, _vm.set_appraisal_land_infrastructure_sewage_execution_pct],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Public_lighting')) + " "), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.land_infrastructure_public_lighting),
        expression: "appraisal.land_infrastructure_public_lighting"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.land_infrastructure_public_lighting) ? _vm._i(_vm.appraisal.land_infrastructure_public_lighting, null) > -1 : (_vm.appraisal.land_infrastructure_public_lighting)
      },
      on: {
        "click": _vm.set_appraisal_land_infrastructure_public_lighting,
        "__c": function($event) {
          var $$a = _vm.appraisal.land_infrastructure_public_lighting,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.land_infrastructure_public_lighting = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.land_infrastructure_public_lighting = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.land_infrastructure_public_lighting = $$c
          }
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Public_lighting_execution_pct')) + " (%)"), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.land_infrastructure_public_lighting_execution_pct),
        expression: "appraisal.land_infrastructure_public_lighting_execution_pct"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.land_infrastructure_public_lighting_execution_pct)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.land_infrastructure_public_lighting_execution_pct = $event.target.value
        }, _vm.set_appraisal_land_infrastructure_public_lighting_execution_pct],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Water_supply')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.land_infrastructure_water_supply),
        expression: "appraisal.land_infrastructure_water_supply"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.land_infrastructure_water_supply) ? _vm._i(_vm.appraisal.land_infrastructure_water_supply, null) > -1 : (_vm.appraisal.land_infrastructure_water_supply)
      },
      on: {
        "click": _vm.set_appraisal_land_infrastructure_water_supply,
        "__c": function($event) {
          var $$a = _vm.appraisal.land_infrastructure_water_supply,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.land_infrastructure_water_supply = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.land_infrastructure_water_supply = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.land_infrastructure_water_supply = $$c
          }
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Water_supply_execution_pct')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.land_infrastructure_water_supply_execution_pct),
        expression: "appraisal.land_infrastructure_water_supply_execution_pct"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.land_infrastructure_water_supply_execution_pct)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.land_infrastructure_water_supply_execution_pct = $event.target.value
        }, _vm.set_appraisal_land_infrastructure_water_supply_execution_pct],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Electricity_supply')) + " "), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.land_infrastructure_electricity_supply),
        expression: "appraisal.land_infrastructure_electricity_supply"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.land_infrastructure_electricity_supply) ? _vm._i(_vm.appraisal.land_infrastructure_electricity_supply, null) > -1 : (_vm.appraisal.land_infrastructure_electricity_supply)
      },
      on: {
        "click": _vm.set_appraisal_land_infrastructure_electricity_supply,
        "__c": function($event) {
          var $$a = _vm.appraisal.land_infrastructure_electricity_supply,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.land_infrastructure_electricity_supply = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.land_infrastructure_electricity_supply = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.land_infrastructure_electricity_supply = $$c
          }
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Electricity_supply_execution_pct')) + " (%)"), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.land_infrastructure_electricity_supply_execution_pct),
        expression: "appraisal.land_infrastructure_electricity_supply_execution_pct"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.land_infrastructure_electricity_supply_execution_pct)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.land_infrastructure_electricity_supply_execution_pct = $event.target.value
        }, _vm.set_appraisal_land_infrastructure_electricity_supply_execution_pct],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Piped_gas')) + " "), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.land_infrastructure_piped_gas),
        expression: "appraisal.land_infrastructure_piped_gas"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.land_infrastructure_piped_gas) ? _vm._i(_vm.appraisal.land_infrastructure_piped_gas, null) > -1 : (_vm.appraisal.land_infrastructure_piped_gas)
      },
      on: {
        "click": _vm.set_appraisal_land_infrastructure_piped_gas,
        "__c": function($event) {
          var $$a = _vm.appraisal.land_infrastructure_piped_gas,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.land_infrastructure_piped_gas = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.land_infrastructure_piped_gas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.land_infrastructure_piped_gas = $$c
          }
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Piped_gas_execution_pct')) + " (%)"), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.land_infrastructure_piped_gas_execution_pct),
        expression: "appraisal.land_infrastructure_piped_gas_execution_pct"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.land_infrastructure_piped_gas_execution_pct)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.land_infrastructure_piped_gas_execution_pct = $event.target.value
        }, _vm.set_appraisal_land_infrastructure_piped_gas_execution_pct],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Telephone_service')) + " "), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.land_infrastructure_telephone_service),
        expression: "appraisal.land_infrastructure_telephone_service"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.land_infrastructure_telephone_service) ? _vm._i(_vm.appraisal.land_infrastructure_telephone_service, null) > -1 : (_vm.appraisal.land_infrastructure_telephone_service)
      },
      on: {
        "click": _vm.set_appraisal_land_infrastructure_telephone_service,
        "__c": function($event) {
          var $$a = _vm.appraisal.land_infrastructure_telephone_service,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.land_infrastructure_telephone_service = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.land_infrastructure_telephone_service = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.land_infrastructure_telephone_service = $$c
          }
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Telephone_service_execution_pct')) + " (%)"), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.land_infrastructure_telephone_service_execution_pct),
        expression: "appraisal.land_infrastructure_telephone_service_execution_pct"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.land_infrastructure_telephone_service_execution_pct)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.land_infrastructure_telephone_service_execution_pct = $event.target.value
        }, _vm.set_appraisal_land_infrastructure_telephone_service_execution_pct],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Gardened_areas')) + " "), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.land_infrastructure_gardened_areas),
        expression: "appraisal.land_infrastructure_gardened_areas"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.land_infrastructure_gardened_areas) ? _vm._i(_vm.appraisal.land_infrastructure_gardened_areas, null) > -1 : (_vm.appraisal.land_infrastructure_gardened_areas)
      },
      on: {
        "click": _vm.set_appraisal_land_infrastructure_gardened_areas,
        "__c": function($event) {
          var $$a = _vm.appraisal.land_infrastructure_gardened_areas,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.land_infrastructure_gardened_areas = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.land_infrastructure_gardened_areas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.land_infrastructure_gardened_areas = $$c
          }
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Gardened_areas_execution_pct')) + " (%)"), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.land_infrastructure_gardened_areas_execution_pct),
        expression: "appraisal.land_infrastructure_gardened_areas_execution_pct"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.land_infrastructure_gardened_areas_execution_pct)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.land_infrastructure_gardened_areas_execution_pct = $event.target.value
        }, _vm.set_appraisal_land_infrastructure_gardened_areas_execution_pct],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_c('strong', [_vm._v(_vm._s(_vm.$t('Total_execution_pct')) + " (%)")]), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.land_infrastructure_total_execution_pct)) + " %")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Conservation_status')) + " "), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.land_infrastructure_conservation_statusValue,
        "options": _vm.conservation_statusOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_land_infrastructure_conservation_status
      },
      model: {
        value: (_vm.appraisal.land_infrastructure_conservation_status),
        callback: function($$v) {
          _vm.appraisal.land_infrastructure_conservation_status = $$v
        },
        expression: "appraisal.land_infrastructure_conservation_status"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Infrastructures_repercussion_cost')) + " (€/m²)"), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.land_infrastructure_repercussion_cost),
        expression: "appraisal.land_infrastructure_repercussion_cost"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.land_infrastructure_repercussion_cost)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.land_infrastructure_repercussion_cost = $event.target.value
        }, _vm.set_appraisal_land_infrastructure_repercussion_cost],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Pending_investment')) + " (€/m²)"), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm._f("formatNumber")(_vm.appraisal.land_infrastructure_pending_investment)) + " €/m²")])])])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Notes_on_plot_infrastructures')) + " "), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.land_infrastructure_notes),
        expression: "appraisal.land_infrastructure_notes"
      }],
      staticClass: "field__group__textarea",
      attrs: {
        "rows": "5",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.land_infrastructure_notes)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.land_infrastructure_notes = $event.target.value
        }, _vm.set_appraisal_land_infrastructure_notes]
      }
    })])])])])])])])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.features_text
      }
    }, [(_vm.currentLocale === 'ca') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Característiques')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.features_text) + "\n\t\t\t\t\t\t\t")]) : (_vm.currentLocale === 'en') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Features')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.features_text) + "\n\t\t\t\t\t\t\t")]) : _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Características')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.features_text) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "form-section"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Number_of_floors_and_use')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Floors_number_underground')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.floors_number_underground),
        expression: "appraisal.floors_number_underground"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.floors_number_underground)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.floors_number_underground = $event.target.value
        }, _vm.set_appraisal_floors_number_underground],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Floors_usage_underground')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.floors_usage_undergroundValue,
        "options": _vm.usage_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_floors_usage_underground
      },
      model: {
        value: (_vm.appraisal.floors_usage_underground),
        callback: function($$v) {
          _vm.appraisal.floors_usage_underground = $$v
        },
        expression: "appraisal.floors_usage_underground"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Groundfloor_usage')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.groundfloor_usageValue,
        "options": _vm.usage_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_groundfloor_usage
      },
      model: {
        value: (_vm.appraisal.groundfloor_usage),
        callback: function($$v) {
          _vm.appraisal.groundfloor_usage = $$v
        },
        expression: "appraisal.groundfloor_usage"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Floors_number_overground')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.floors_number_overground),
        expression: "appraisal.floors_number_overground"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.floors_number_overground)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.floors_number_overground = $event.target.value
        }, _vm.set_appraisal_floors_number_overground],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Floors_usage_overground')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.floors_usage_overgroundValue,
        "options": _vm.usage_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_floors_usage_overground
      },
      model: {
        value: (_vm.appraisal.floors_usage_overground),
        callback: function($$v) {
          _vm.appraisal.floors_usage_overground = $$v
        },
        expression: "appraisal.floors_usage_overground"
      }
    })], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Features')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('table', {
      staticStyle: {
        "width": "30em"
      }
    }, [_c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Lift')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.lift),
        expression: "appraisal.lift"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.lift) ? _vm._i(_vm.appraisal.lift, null) > -1 : (_vm.appraisal.lift)
      },
      on: {
        "input": _vm.set_appraisal_lift,
        "__c": function($event) {
          var $$a = _vm.appraisal.lift,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.lift = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.lift = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.lift = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Entrance_hall')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.entrance_hall),
        expression: "appraisal.entrance_hall"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.entrance_hall) ? _vm._i(_vm.appraisal.entrance_hall, null) > -1 : (_vm.appraisal.entrance_hall)
      },
      on: {
        "click": _vm.set_appraisal_entrance_hall,
        "__c": function($event) {
          var $$a = _vm.appraisal.entrance_hall,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.entrance_hall = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.entrance_hall = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.entrance_hall = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Doorman_space')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.doorman_space),
        expression: "appraisal.doorman_space"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.doorman_space) ? _vm._i(_vm.appraisal.doorman_space, null) > -1 : (_vm.appraisal.doorman_space)
      },
      on: {
        "click": _vm.set_appraisal_doorman_space,
        "__c": function($event) {
          var $$a = _vm.appraisal.doorman_space,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.doorman_space = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.doorman_space = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.doorman_space = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Staircase')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.staircase),
        expression: "appraisal.staircase"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.staircase) ? _vm._i(_vm.appraisal.staircase, null) > -1 : (_vm.appraisal.staircase)
      },
      on: {
        "click": _vm.set_appraisal_staircase,
        "__c": function($event) {
          var $$a = _vm.appraisal.staircase,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.staircase = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.staircase = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.staircase = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Swimming_pool')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.swimming_pool),
        expression: "appraisal.swimming_pool"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.swimming_pool) ? _vm._i(_vm.appraisal.swimming_pool, null) > -1 : (_vm.appraisal.swimming_pool)
      },
      on: {
        "click": _vm.set_appraisal_swimming_pool,
        "__c": function($event) {
          var $$a = _vm.appraisal.swimming_pool,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.swimming_pool = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.swimming_pool = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.swimming_pool = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Gardened_areas')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.gardened_areas),
        expression: "appraisal.gardened_areas"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.gardened_areas) ? _vm._i(_vm.appraisal.gardened_areas, null) > -1 : (_vm.appraisal.gardened_areas)
      },
      on: {
        "click": _vm.set_appraisal_gardened_areas,
        "__c": function($event) {
          var $$a = _vm.appraisal.gardened_areas,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.gardened_areas = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.gardened_areas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.gardened_areas = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Sports_facilities')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.sports_facilities),
        expression: "appraisal.sports_facilities"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.sports_facilities) ? _vm._i(_vm.appraisal.sports_facilities, null) > -1 : (_vm.appraisal.sports_facilities)
      },
      on: {
        "click": _vm.set_appraisal_sports_facilities,
        "__c": function($event) {
          var $$a = _vm.appraisal.sports_facilities,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.sports_facilities = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.sports_facilities = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.sports_facilities = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Community_room')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.community_room),
        expression: "appraisal.community_room"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.community_room) ? _vm._i(_vm.appraisal.community_room, null) > -1 : (_vm.appraisal.community_room)
      },
      on: {
        "click": _vm.set_appraisal_community_room,
        "__c": function($event) {
          var $$a = _vm.appraisal.community_room,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.community_room = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.community_room = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.community_room = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Community_parking')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.community_parking),
        expression: "appraisal.community_parking"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.community_parking) ? _vm._i(_vm.appraisal.community_parking, null) > -1 : (_vm.appraisal.community_parking)
      },
      on: {
        "click": _vm.set_appraisal_community_parking,
        "__c": function($event) {
          var $$a = _vm.appraisal.community_parking,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.community_parking = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.community_parking = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.community_parking = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Facilities_others')))]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.facilities_others),
        expression: "appraisal.facilities_others"
      }],
      staticClass: "field__group__textarea",
      attrs: {
        "rows": "3",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.facilities_others)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.facilities_others = $event.target.value
        }, _vm.set_appraisal_facilities_others]
      }
    })])])])])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Qualities')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Quality_of_neighbourhood')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.quality_of_neighbourhoodValue,
        "options": _vm.quality_of_neighbourhoodOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_quality_of_neighbourhood
      },
      model: {
        value: (_vm.appraisal.quality_of_neighbourhood),
        callback: function($$v) {
          _vm.appraisal.quality_of_neighbourhood = $$v
        },
        expression: "appraisal.quality_of_neighbourhood"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Quality_of_situation')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.quality_of_situationValue,
        "options": _vm.quality_of_situationOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_quality_of_situation
      },
      model: {
        value: (_vm.appraisal.quality_of_situation),
        callback: function($$v) {
          _vm.appraisal.quality_of_situation = $$v
        },
        expression: "appraisal.quality_of_situation"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Quality_of_construction')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.quality_of_constructionValue,
        "options": _vm.quality_of_constructionOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_quality_of_construction
      },
      model: {
        value: (_vm.appraisal.quality_of_construction),
        callback: function($$v) {
          _vm.appraisal.quality_of_construction = $$v
        },
        expression: "appraisal.quality_of_construction"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Quality_of_realestate')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.quality_of_realestateValue,
        "options": _vm.quality_of_realestateOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_quality_of_realestate
      },
      model: {
        value: (_vm.appraisal.quality_of_realestate),
        callback: function($$v) {
          _vm.appraisal.quality_of_realestate = $$v
        },
        expression: "appraisal.quality_of_realestate"
      }
    })], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Age')) + " " + _vm._s(_vm.$t('and')) + " " + _vm._s(_vm.$t('conservation_status')) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Construction_year')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.construction_year),
        expression: "appraisal.construction_year"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.construction_year)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.construction_year = $event.target.value
        }, _vm.set_appraisal_construction_year],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Last_renovation_year')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.last_renovation_year),
        expression: "appraisal.last_renovation_year"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.last_renovation_year)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.last_renovation_year = $event.target.value
        }, _vm.set_appraisal_last_renovation_year],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Adopted_age')) + " (" + _vm._s(_vm.$t('Average')) + ")")]), _vm._v(" "), _c('strong', [_c('span', [_vm._v(_vm._s(_vm.appraisal.adopted_age))])])])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Conservation_status')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.conservation_statusValue,
        "options": _vm.conservation_statusOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_conservation_status
      },
      model: {
        value: (_vm.appraisal.conservation_status),
        callback: function($$v) {
          _vm.appraisal.conservation_status = $$v
        },
        expression: "appraisal.conservation_status"
      }
    })], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Structure')) + " " + _vm._s(_vm.$t('and')) + " " + _vm._s(_vm.$t('shell')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Foundation')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_foundationValue,
        "options": _vm.foundationOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_foundation
      },
      model: {
        value: (_vm.appraisal.realestate_foundation),
        callback: function($$v) {
          _vm.appraisal.realestate_foundation = $$v
        },
        expression: "appraisal.realestate_foundation"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Structure')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_structureValue,
        "options": _vm.structureOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_structure
      },
      model: {
        value: (_vm.appraisal.realestate_structure),
        callback: function($$v) {
          _vm.appraisal.realestate_structure = $$v
        },
        expression: "appraisal.realestate_structure"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Roof')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_roofValue,
        "options": _vm.roofOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_roof
      },
      model: {
        value: (_vm.appraisal.realestate_roof),
        callback: function($$v) {
          _vm.appraisal.realestate_roof = $$v
        },
        expression: "appraisal.realestate_roof"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('External_enclosures')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_external_enclosuresValue,
        "options": _vm.external_enclosuresOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_external_enclosures
      },
      model: {
        value: (_vm.appraisal.realestate_external_enclosures),
        callback: function($$v) {
          _vm.appraisal.realestate_external_enclosures = $$v
        },
        expression: "appraisal.realestate_external_enclosures"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Insulation')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_insulationValue,
        "options": _vm.insulationOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_insulation
      },
      model: {
        value: (_vm.appraisal.realestate_insulation),
        callback: function($$v) {
          _vm.appraisal.realestate_insulation = $$v
        },
        expression: "appraisal.realestate_insulation"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('External_carpentry')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_external_carpentryValue,
        "options": _vm.external_carpentry_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_external_carpentry
      },
      model: {
        value: (_vm.appraisal.realestate_external_carpentry),
        callback: function($$v) {
          _vm.appraisal.realestate_external_carpentry = $$v
        },
        expression: "appraisal.realestate_external_carpentry"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Glazing')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_glazingValue,
        "options": _vm.glazingOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_glazing
      },
      model: {
        value: (_vm.appraisal.realestate_glazing),
        callback: function($$v) {
          _vm.appraisal.realestate_glazing = $$v
        },
        expression: "appraisal.realestate_glazing"
      }
    })], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Interior_finishes')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "calc_table overflow_auto"
    }, [_c('table', {
      staticClass: "table-striped",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('tr', [_c('th', {
      staticStyle: {
        "width": "200px"
      }
    }), _vm._v(" "), _c('th', {
      staticStyle: {
        "width": "300px"
      }
    }, [_vm._v(_vm._s(_vm.$t('Paving')))]), _vm._v(" "), _c('th', {
      staticStyle: {
        "width": "300px"
      }
    }, [_vm._v(_vm._s(_vm.$t('Walls')))]), _vm._v(" "), _c('th', {
      staticStyle: {
        "width": "300px"
      }
    }, [_vm._v(_vm._s(_vm.$t('Ceilings')))]), _vm._v(" "), _c('th', {
      staticStyle: {
        "width": "300px"
      }
    }, [_vm._v(_vm._s(_vm.$t('Interior_carpentry')) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [(_vm.appraisal.property_type.name_db == 'residential') ? _c('strong', [_vm._v(_vm._s(_vm.$t('Living')))]) : _c('strong', [_vm._v("General")])]), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_interior_paving_livingValue,
        "options": _vm.pavingOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_interior_paving_living
      },
      model: {
        value: (_vm.appraisal.realestate_interior_paving_living),
        callback: function($$v) {
          _vm.appraisal.realestate_interior_paving_living = $$v
        },
        expression: "appraisal.realestate_interior_paving_living"
      }
    })], 1), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_interior_walls_livingValue,
        "options": _vm.wallsOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_interior_walls_living
      },
      model: {
        value: (_vm.appraisal.realestate_interior_walls_living),
        callback: function($$v) {
          _vm.appraisal.realestate_interior_walls_living = $$v
        },
        expression: "appraisal.realestate_interior_walls_living"
      }
    })], 1), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_interior_ceilings_livingValue,
        "options": _vm.ceilingsOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_interior_ceilings_living
      },
      model: {
        value: (_vm.appraisal.realestate_interior_ceilings_living),
        callback: function($$v) {
          _vm.appraisal.realestate_interior_ceilings_living = $$v
        },
        expression: "appraisal.realestate_interior_ceilings_living"
      }
    })], 1), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_interior_carpentry_livingValue,
        "options": _vm.interior_carpentry_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_interior_carpentry_living
      },
      model: {
        value: (_vm.appraisal.realestate_interior_carpentry_living),
        callback: function($$v) {
          _vm.appraisal.realestate_interior_carpentry_living = $$v
        },
        expression: "appraisal.realestate_interior_carpentry_living"
      }
    })], 1)]), _vm._v(" "), (_vm.appraisal.property_type.name_db == 'residential') ? _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.$t('Circulations')))])]), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_interior_paving_corridorValue,
        "options": _vm.pavingOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_interior_paving_corridor
      },
      model: {
        value: (_vm.appraisal.realestate_interior_paving_corridor),
        callback: function($$v) {
          _vm.appraisal.realestate_interior_paving_corridor = $$v
        },
        expression: "appraisal.realestate_interior_paving_corridor"
      }
    })], 1), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_interior_walls_corridorValue,
        "options": _vm.wallsOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_interior_walls_corridor
      },
      model: {
        value: (_vm.appraisal.realestate_interior_walls_corridor),
        callback: function($$v) {
          _vm.appraisal.realestate_interior_walls_corridor = $$v
        },
        expression: "appraisal.realestate_interior_walls_corridor"
      }
    })], 1), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_interior_ceilings_corridorValue,
        "options": _vm.ceilingsOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_interior_ceilings_corridor
      },
      model: {
        value: (_vm.appraisal.realestate_interior_ceilings_corridor),
        callback: function($$v) {
          _vm.appraisal.realestate_interior_ceilings_corridor = $$v
        },
        expression: "appraisal.realestate_interior_ceilings_corridor"
      }
    })], 1), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_interior_carpentry_corridorValue,
        "options": _vm.interior_carpentry_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_interior_carpentry_corridor
      },
      model: {
        value: (_vm.appraisal.realestate_interior_carpentry_corridor),
        callback: function($$v) {
          _vm.appraisal.realestate_interior_carpentry_corridor = $$v
        },
        expression: "appraisal.realestate_interior_carpentry_corridor"
      }
    })], 1)]) : _vm._e(), _vm._v(" "), (_vm.appraisal.property_type.name_db == 'residential') ? _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.$t('Bedrooms')))])]), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_interior_paving_bedroomValue,
        "options": _vm.pavingOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_interior_paving_bedroom
      },
      model: {
        value: (_vm.appraisal.realestate_interior_paving_bedroom),
        callback: function($$v) {
          _vm.appraisal.realestate_interior_paving_bedroom = $$v
        },
        expression: "appraisal.realestate_interior_paving_bedroom"
      }
    })], 1), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_interior_walls_bedroomValue,
        "options": _vm.wallsOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_interior_walls_bedroom
      },
      model: {
        value: (_vm.appraisal.realestate_interior_walls_bedroom),
        callback: function($$v) {
          _vm.appraisal.realestate_interior_walls_bedroom = $$v
        },
        expression: "appraisal.realestate_interior_walls_bedroom"
      }
    })], 1), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_interior_ceilings_bedroomValue,
        "options": _vm.ceilingsOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_interior_ceilings_bedroom
      },
      model: {
        value: (_vm.appraisal.realestate_interior_ceilings_bedroom),
        callback: function($$v) {
          _vm.appraisal.realestate_interior_ceilings_bedroom = $$v
        },
        expression: "appraisal.realestate_interior_ceilings_bedroom"
      }
    })], 1), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_interior_carpentry_bedroomValue,
        "options": _vm.interior_carpentry_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_interior_carpentry_bedroom
      },
      model: {
        value: (_vm.appraisal.realestate_interior_carpentry_bedroom),
        callback: function($$v) {
          _vm.appraisal.realestate_interior_carpentry_bedroom = $$v
        },
        expression: "appraisal.realestate_interior_carpentry_bedroom"
      }
    })], 1)]) : _vm._e(), _vm._v(" "), (_vm.appraisal.property_type.name_db == 'residential') ? _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.$t('Kitchen')))])]), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_interior_paving_kitchenValue,
        "options": _vm.pavingOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_interior_paving_kitchen
      },
      model: {
        value: (_vm.appraisal.realestate_interior_paving_kitchen),
        callback: function($$v) {
          _vm.appraisal.realestate_interior_paving_kitchen = $$v
        },
        expression: "appraisal.realestate_interior_paving_kitchen"
      }
    })], 1), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_interior_walls_kitchenValue,
        "options": _vm.wallsOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_interior_walls_kitchen
      },
      model: {
        value: (_vm.appraisal.realestate_interior_walls_kitchen),
        callback: function($$v) {
          _vm.appraisal.realestate_interior_walls_kitchen = $$v
        },
        expression: "appraisal.realestate_interior_walls_kitchen"
      }
    })], 1), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_interior_ceilings_kitchenValue,
        "options": _vm.ceilingsOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_interior_ceilings_kitchen
      },
      model: {
        value: (_vm.appraisal.realestate_interior_ceilings_kitchen),
        callback: function($$v) {
          _vm.appraisal.realestate_interior_ceilings_kitchen = $$v
        },
        expression: "appraisal.realestate_interior_ceilings_kitchen"
      }
    })], 1), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_interior_carpentry_kitchenValue,
        "options": _vm.interior_carpentry_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_interior_carpentry_kitchen
      },
      model: {
        value: (_vm.appraisal.realestate_interior_carpentry_kitchen),
        callback: function($$v) {
          _vm.appraisal.realestate_interior_carpentry_kitchen = $$v
        },
        expression: "appraisal.realestate_interior_carpentry_kitchen"
      }
    })], 1)]) : _vm._e(), _vm._v(" "), (_vm.appraisal.property_type.name_db == 'residential' || _vm.appraisal.property_type.name_db == 'retail_and_industrial' || _vm.appraisal.property_type.name_db == 'office') ? _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.$t('Bathrooms')))])]), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_interior_paving_bathroomValue,
        "options": _vm.pavingOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_interior_paving_bathroom
      },
      model: {
        value: (_vm.appraisal.realestate_interior_paving_bathroom),
        callback: function($$v) {
          _vm.appraisal.realestate_interior_paving_bathroom = $$v
        },
        expression: "appraisal.realestate_interior_paving_bathroom"
      }
    })], 1), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_interior_walls_bathroomValue,
        "options": _vm.wallsOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_interior_walls_bathroom
      },
      model: {
        value: (_vm.appraisal.realestate_interior_walls_bathroom),
        callback: function($$v) {
          _vm.appraisal.realestate_interior_walls_bathroom = $$v
        },
        expression: "appraisal.realestate_interior_walls_bathroom"
      }
    })], 1), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_interior_ceilings_bathroomValue,
        "options": _vm.ceilingsOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_interior_ceilings_bathroom
      },
      model: {
        value: (_vm.appraisal.realestate_interior_ceilings_bathroom),
        callback: function($$v) {
          _vm.appraisal.realestate_interior_ceilings_bathroom = $$v
        },
        expression: "appraisal.realestate_interior_ceilings_bathroom"
      }
    })], 1), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_interior_carpentry_bathroomValue,
        "options": _vm.interior_carpentry_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_interior_carpentry_bathroom
      },
      model: {
        value: (_vm.appraisal.realestate_interior_carpentry_bathroom),
        callback: function($$v) {
          _vm.appraisal.realestate_interior_carpentry_bathroom = $$v
        },
        expression: "appraisal.realestate_interior_carpentry_bathroom"
      }
    })], 1)]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.$t('Quality')))])]), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_interior_paving_qualityValue,
        "options": _vm.quality_of_finishesOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_interior_paving_quality
      },
      model: {
        value: (_vm.appraisal.realestate_interior_paving_quality),
        callback: function($$v) {
          _vm.appraisal.realestate_interior_paving_quality = $$v
        },
        expression: "appraisal.realestate_interior_paving_quality"
      }
    })], 1), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_interior_walls_qualityValue,
        "options": _vm.quality_of_finishesOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_interior_walls_quality
      },
      model: {
        value: (_vm.appraisal.realestate_interior_walls_quality),
        callback: function($$v) {
          _vm.appraisal.realestate_interior_walls_quality = $$v
        },
        expression: "appraisal.realestate_interior_walls_quality"
      }
    })], 1), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_interior_ceilings_qualityValue,
        "options": _vm.quality_of_finishesOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_interior_ceilings_quality
      },
      model: {
        value: (_vm.appraisal.realestate_interior_ceilings_quality),
        callback: function($$v) {
          _vm.appraisal.realestate_interior_ceilings_quality = $$v
        },
        expression: "appraisal.realestate_interior_ceilings_quality"
      }
    })], 1), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_interior_carpentry_qualityValue,
        "options": _vm.quality_of_finishesOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_interior_carpentry_quality
      },
      model: {
        value: (_vm.appraisal.realestate_interior_carpentry_quality),
        callback: function($$v) {
          _vm.appraisal.realestate_interior_carpentry_quality = $$v
        },
        expression: "appraisal.realestate_interior_carpentry_quality"
      }
    })], 1)])])])])]), _vm._v(" "), (_vm.appraisal.property_type.name_db == 'residential') ? _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Habitability_conditions')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Number_of_rooms_to_exterior')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.realestate_rooms_to_exterior_number),
        expression: "appraisal.realestate_rooms_to_exterior_number"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.realestate_rooms_to_exterior_number)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.realestate_rooms_to_exterior_number = $event.target.value
        }, _vm.set_appraisal_realestate_rooms_to_exterior_number],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Main_orientation')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_main_orientationValue,
        "options": _vm.main_orientationOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_main_orientation
      },
      model: {
        value: (_vm.appraisal.realestate_main_orientation),
        callback: function($$v) {
          _vm.appraisal.realestate_main_orientation = $$v
        },
        expression: "appraisal.realestate_main_orientation"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Views')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_main_viewsValue,
        "options": _vm.main_viewsOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_main_views
      },
      model: {
        value: (_vm.appraisal.realestate_main_views),
        callback: function($$v) {
          _vm.appraisal.realestate_main_views = $$v
        },
        expression: "appraisal.realestate_main_views"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Windows_size_and_quantity')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_windows_size_and_quantityValue,
        "options": _vm.windows_size_and_quantityOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_windows_size_and_quantity
      },
      model: {
        value: (_vm.appraisal.realestate_windows_size_and_quantity),
        callback: function($$v) {
          _vm.appraisal.realestate_windows_size_and_quantity = $$v
        },
        expression: "appraisal.realestate_windows_size_and_quantity"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Noise_facade')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_noise_facadeValue,
        "options": _vm.noise_levelOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_noise_facade
      },
      model: {
        value: (_vm.appraisal.realestate_noise_facade),
        callback: function($$v) {
          _vm.appraisal.realestate_noise_facade = $$v
        },
        expression: "appraisal.realestate_noise_facade"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Day_night_zoning')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.realestate_day_night_zoning),
        expression: "appraisal.realestate_day_night_zoning"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.realestate_day_night_zoning) ? _vm._i(_vm.appraisal.realestate_day_night_zoning, null) > -1 : (_vm.appraisal.realestate_day_night_zoning)
      },
      on: {
        "click": _vm.set_appraisal_realestate_day_night_zoning,
        "__c": function($event) {
          var $$a = _vm.appraisal.realestate_day_night_zoning,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.realestate_day_night_zoning = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.realestate_day_night_zoning = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.realestate_day_night_zoning = $$c
          }
        }
      }
    })])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Systems')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('table', {
      staticStyle: {
        "width": "40em"
      }
    }, [_c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Door_opener')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.realestate_systems_door_opener),
        expression: "appraisal.realestate_systems_door_opener"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.realestate_systems_door_opener) ? _vm._i(_vm.appraisal.realestate_systems_door_opener, null) > -1 : (_vm.appraisal.realestate_systems_door_opener)
      },
      on: {
        "click": _vm.set_appraisal_realestate_systems_door_opener,
        "__c": function($event) {
          var $$a = _vm.appraisal.realestate_systems_door_opener,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.realestate_systems_door_opener = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.realestate_systems_door_opener = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.realestate_systems_door_opener = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Fitted_cupboards')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.realestate_systems_fitted_cupboards),
        expression: "appraisal.realestate_systems_fitted_cupboards"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.realestate_systems_fitted_cupboards) ? _vm._i(_vm.appraisal.realestate_systems_fitted_cupboards, null) > -1 : (_vm.appraisal.realestate_systems_fitted_cupboards)
      },
      on: {
        "click": _vm.set_appraisal_realestate_systems_fitted_cupboards,
        "__c": function($event) {
          var $$a = _vm.appraisal.realestate_systems_fitted_cupboards,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.realestate_systems_fitted_cupboards = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.realestate_systems_fitted_cupboards = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.realestate_systems_fitted_cupboards = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Gas')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.realestate_systems_gas),
        expression: "appraisal.realestate_systems_gas"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.realestate_systems_gas) ? _vm._i(_vm.appraisal.realestate_systems_gas, null) > -1 : (_vm.appraisal.realestate_systems_gas)
      },
      on: {
        "click": _vm.set_appraisal_realestate_systems_gas,
        "__c": function($event) {
          var $$a = _vm.appraisal.realestate_systems_gas,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.realestate_systems_gas = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.realestate_systems_gas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.realestate_systems_gas = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "width": "15em"
      }
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Sanitary_fittings')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.realestate_systems_sanitary_fittings),
        expression: "appraisal.realestate_systems_sanitary_fittings"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.realestate_systems_sanitary_fittings) ? _vm._i(_vm.appraisal.realestate_systems_sanitary_fittings, null) > -1 : (_vm.appraisal.realestate_systems_sanitary_fittings)
      },
      on: {
        "click": _vm.set_appraisal_realestate_systems_sanitary_fittings,
        "__c": function($event) {
          var $$a = _vm.appraisal.realestate_systems_sanitary_fittings,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.realestate_systems_sanitary_fittings = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.realestate_systems_sanitary_fittings = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.realestate_systems_sanitary_fittings = $$c
          }
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Sanitary_fittings_quality')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_systems_sanitary_fittings_qualityValue,
        "options": _vm.quality_of_finishesOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_systems_sanitary_fittings_quality
      },
      model: {
        value: (_vm.appraisal.realestate_systems_sanitary_fittings_quality),
        callback: function($$v) {
          _vm.appraisal.realestate_systems_sanitary_fittings_quality = $$v
        },
        expression: "appraisal.realestate_systems_sanitary_fittings_quality"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Taps')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.realestate_systems_taps),
        expression: "appraisal.realestate_systems_taps"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.realestate_systems_taps) ? _vm._i(_vm.appraisal.realestate_systems_taps, null) > -1 : (_vm.appraisal.realestate_systems_taps)
      },
      on: {
        "click": _vm.set_appraisal_realestate_systems_taps,
        "__c": function($event) {
          var $$a = _vm.appraisal.realestate_systems_taps,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.realestate_systems_taps = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.realestate_systems_taps = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.realestate_systems_taps = $$c
          }
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Taps_quality')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_systems_taps_qualityValue,
        "options": _vm.quality_of_finishesOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_systems_taps_quality
      },
      model: {
        value: (_vm.appraisal.realestate_systems_taps_quality),
        callback: function($$v) {
          _vm.appraisal.realestate_systems_taps_quality = $$v
        },
        expression: "appraisal.realestate_systems_taps_quality"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Hot_water')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.realestate_systems_hot_water),
        expression: "appraisal.realestate_systems_hot_water"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.realestate_systems_hot_water) ? _vm._i(_vm.appraisal.realestate_systems_hot_water, null) > -1 : (_vm.appraisal.realestate_systems_hot_water)
      },
      on: {
        "click": _vm.set_appraisal_realestate_systems_hot_water,
        "__c": function($event) {
          var $$a = _vm.appraisal.realestate_systems_hot_water,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.realestate_systems_hot_water = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.realestate_systems_hot_water = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.realestate_systems_hot_water = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Heating')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.realestate_systems_heating),
        expression: "appraisal.realestate_systems_heating"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.realestate_systems_heating) ? _vm._i(_vm.appraisal.realestate_systems_heating, null) > -1 : (_vm.appraisal.realestate_systems_heating)
      },
      on: {
        "click": _vm.set_appraisal_realestate_systems_heating,
        "__c": function($event) {
          var $$a = _vm.appraisal.realestate_systems_heating,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.realestate_systems_heating = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.realestate_systems_heating = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.realestate_systems_heating = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Air_conditioning')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.realestate_systems_air_conditioning),
        expression: "appraisal.realestate_systems_air_conditioning"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.realestate_systems_air_conditioning) ? _vm._i(_vm.appraisal.realestate_systems_air_conditioning, null) > -1 : (_vm.appraisal.realestate_systems_air_conditioning)
      },
      on: {
        "click": _vm.set_appraisal_realestate_systems_air_conditioning,
        "__c": function($event) {
          var $$a = _vm.appraisal.realestate_systems_air_conditioning,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.realestate_systems_air_conditioning = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.realestate_systems_air_conditioning = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.realestate_systems_air_conditioning = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v("Tv")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.realestate_systems_tv),
        expression: "appraisal.realestate_systems_tv"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.realestate_systems_tv) ? _vm._i(_vm.appraisal.realestate_systems_tv, null) > -1 : (_vm.appraisal.realestate_systems_tv)
      },
      on: {
        "click": _vm.set_appraisal_realestate_systems_tv,
        "__c": function($event) {
          var $$a = _vm.appraisal.realestate_systems_tv,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.realestate_systems_tv = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.realestate_systems_tv = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.realestate_systems_tv = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Telephone')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.realestate_systems_telephone),
        expression: "appraisal.realestate_systems_telephone"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.realestate_systems_telephone) ? _vm._i(_vm.appraisal.realestate_systems_telephone, null) > -1 : (_vm.appraisal.realestate_systems_telephone)
      },
      on: {
        "click": _vm.set_appraisal_realestate_systems_telephone,
        "__c": function($event) {
          var $$a = _vm.appraisal.realestate_systems_telephone,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.realestate_systems_telephone = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.realestate_systems_telephone = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.realestate_systems_telephone = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Fire_prevention')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.realestate_systems_fire_prevention),
        expression: "appraisal.realestate_systems_fire_prevention"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.realestate_systems_fire_prevention) ? _vm._i(_vm.appraisal.realestate_systems_fire_prevention, null) > -1 : (_vm.appraisal.realestate_systems_fire_prevention)
      },
      on: {
        "click": _vm.set_appraisal_realestate_systems_fire_prevention,
        "__c": function($event) {
          var $$a = _vm.appraisal.realestate_systems_fire_prevention,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.realestate_systems_fire_prevention = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.realestate_systems_fire_prevention = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.realestate_systems_fire_prevention = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Intrusion_prevention')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.realestate_systems_intrusion_prevention),
        expression: "appraisal.realestate_systems_intrusion_prevention"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.realestate_systems_intrusion_prevention) ? _vm._i(_vm.appraisal.realestate_systems_intrusion_prevention, null) > -1 : (_vm.appraisal.realestate_systems_intrusion_prevention)
      },
      on: {
        "click": _vm.set_appraisal_realestate_systems_intrusion_prevention,
        "__c": function($event) {
          var $$a = _vm.appraisal.realestate_systems_intrusion_prevention,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.realestate_systems_intrusion_prevention = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.realestate_systems_intrusion_prevention = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.realestate_systems_intrusion_prevention = $$c
          }
        }
      }
    })])])])])])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Real_estates_useful_life')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Real_estates_total_useful_life')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.useful_life_years),
        expression: "appraisal.useful_life_years"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.useful_life_years)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.useful_life_years = $event.target.value
        }, _vm.set_appraisal_useful_life_years],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Remaining_useful_life_years')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.appraisal.remaining_useful_life_years) + " " + _vm._s(_vm.$t('years')))])])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Construction_cost')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Property_type')) + " (B.E.C.)")]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.bec_property_typeValue,
        "options": this.object_to_array(_vm.appraisal_bec_properties),
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_bec_property_type
      },
      model: {
        value: (_vm.appraisal.bec_property_type),
        callback: function($$v) {
          _vm.appraisal.bec_property_type = $$v
        },
        expression: "appraisal.bec_property_type"
      }
    })], 1), _vm._v(" "), (_vm.appraisal.bec_property_type) ? _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Number')) + " (B.E.C.)")]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.bec_numberValue,
        "options": this.object_to_array(_vm.appraisal_bec_prices),
        "track-by": "id",
        "label": 'number',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_bec_number
      },
      model: {
        value: (_vm.appraisal.bec_number),
        callback: function($$v) {
          _vm.appraisal.bec_number = $$v
        },
        expression: "appraisal.bec_number"
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.appraisal.bec_number) ? _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Year')))]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.appraisal.bec_number.year) + " ")])]) : _vm._e(), _vm._v(" "), (_vm.appraisal.bec_number) ? _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Quarter')))]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.appraisal.bec_number.quarter) + " ")])]) : _vm._e()]), _vm._v(" "), (_vm.appraisal.bec_number) ? _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v("B.E.C. " + _vm._s(_vm.$t('Construction_cost')) + " total")]), _vm._v(" "), _c('strong', [_c('span', [_vm._v(" " + _vm._s(_vm._f("formatNumber")(_vm.appraisal.bec_number.total)) + " €/m²")])])]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Bec_adjustment_coef')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.bec_adjustment_coef),
        expression: "appraisal.bec_adjustment_coef"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "step": "0.05",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.bec_adjustment_coef)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.bec_adjustment_coef = $event.target.value
        }, _vm.set_appraisal_bec_adjustment_coef],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Adjusted_bec_price')))]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm._f("formatNumber")(_vm.appraisal.adjusted_bec_price)) + " €/m²")])])]) : _vm._e(), _vm._v(" "), (_vm.appraisal.bec_number) ? _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Expenses_and_industrial_benefit_bec_pct')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.expenses_and_industrial_benefit_bec_pct),
        expression: "appraisal.expenses_and_industrial_benefit_bec_pct"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.expenses_and_industrial_benefit_bec_pct)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.expenses_and_industrial_benefit_bec_pct = $event.target.value
        }, _vm.set_appraisal_expenses_and_industrial_benefit_bec_pct],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Material_execution_cost')))]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm._f("formatNumber")(_vm.appraisal.material_execution_cost)) + " €/m²")])])]) : _vm._e(), _vm._v(" "), (_vm.appraisal.bec_number) ? _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Mec_adjustment_coef')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.mec_adjustment_coef),
        expression: "appraisal.mec_adjustment_coef"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "step": "0.05",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.mec_adjustment_coef)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.mec_adjustment_coef = $event.target.value
        }, _vm.set_appraisal_mec_adjustment_coef],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Adopted_material_execution_cost')))]), _vm._v(" "), _c('strong', [_c('span', [_vm._v(" " + _vm._s(_vm._f("formatNumber")(_vm.appraisal.adopted_material_execution_cost)) + " €/m²")])])])]) : _vm._e(), _vm._v(" "), (_vm.appraisal.bec_number) ? _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Construction_cost_notes')))]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.construction_cost_notes),
        expression: "appraisal.construction_cost_notes"
      }],
      staticClass: "field__group__textarea",
      attrs: {
        "rows": "5",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.construction_cost_notes)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.construction_cost_notes = $event.target.value
        }, _vm.set_appraisal_construction_cost_notes]
      }
    })])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Construction_status')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Construction_status')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.construction_statusValue,
        "options": _vm.construction_statusOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_construction_status
      },
      model: {
        value: (_vm.appraisal.construction_status),
        callback: function($$v) {
          _vm.appraisal.construction_status = $$v
        },
        expression: "appraisal.construction_status"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Construction_progress_percentage')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.total_construction_progress_pct),
        expression: "appraisal.total_construction_progress_pct"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false",
        "max": "100",
        "step": "1",
        "min": "0"
      },
      domProps: {
        "value": (_vm.appraisal.total_construction_progress_pct)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.total_construction_progress_pct = $event.target.value
        }, _vm.set_appraisal_total_construction_progress_pct],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.appraisal.total_construction_progress_pct < 100) ? _c('span', {
      staticStyle: {
        "background": "lightyellow"
      }
    }, [_c('strong', [_vm._v("Nota:")]), _vm._v(" Degut a que l'immoble es troba en construcció, en els càlculs es forçarà que l'edifici no està depreciat per antiguitat (da = 1 - d = 100%)")]) : _vm._e()])])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.Areas_text
      }
    }, [(_vm.currentLocale === 'ca') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Superfícies')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.Areas_text) + "\n\t\t\t\t\t\t\t")]) : (_vm.currentLocale === 'en') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Areas')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.Areas_text) + "\n\t\t\t\t\t\t\t")]) : _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Superficies')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.Areas_text) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "form-section"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Net_areas')))]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onCreateNewRoom($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus-circle",
        "text": _vm.new_room_button_text,
        "icon_color": "black",
        "text_color": _vm.editing_room_text_color,
        "disabled": _vm.editing_room,
        "border_color": _vm.editing_room_border_color
      }
    })], 1)]), _vm._v(" "), _c('div', {}, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "data-table-main",
        "source": _vm.object_to_array(_vm.appraisal_rooms),
        "filterable": false,
        "striped": _vm.room_table.striped,
        "editable": _vm.room_table.editable,
        "line-numbers": _vm.room_table.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "actions-rooms",
        fn: function(cell) {
          return [_c('table', {
            staticClass: "actions-table"
          }, [_c('tr', [_c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.delete_text
            },
            on: {
              "click": function($event) {
                _vm.deleteRoom(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "trash-o",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)])])])]
        }
      }, {
        key: "netarea",
        fn: function(cell) {
          return [_c('div', {}, [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (cell.row['netarea']),
              expression: "cell.row['netarea']"
            }],
            attrs: {
              "type": "number",
              "min": "0"
            },
            domProps: {
              "value": (cell.row['netarea'])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                var $$exp = cell.row,
                  $$idx = 'netarea';
                if (!Array.isArray($$exp)) {
                  cell.row['netarea'] = $event.target.value
                } else {
                  $$exp.splice($$idx, 1, $event.target.value)
                }
              }, function($event) {
                _vm.set_room_netarea($event, cell.row)
              }],
              "blur": function($event) {
                _vm.$forceUpdate()
              }
            }
          })])]
        }
      }, {
        key: "description",
        fn: function(cell) {
          return [_c('div', {}, [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (cell.row['description']),
              expression: "cell.row['description']"
            }],
            attrs: {
              "type": "text"
            },
            domProps: {
              "value": (cell.row['description'])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                var $$exp = cell.row,
                  $$idx = 'description';
                if (!Array.isArray($$exp)) {
                  cell.row['description'] = $event.target.value
                } else {
                  $$exp.splice($$idx, 1, $event.target.value)
                }
              }, function($event) {
                _vm.set_room_description($event, cell.row)
              }]
            }
          })])]
        }
      }, {
        key: "type",
        fn: function(cell) {
          return [_c('div', [_c('multiselect', {
            attrs: {
              "placeholder": "",
              "value": _vm.room_typeValue,
              "options": _vm.room_typeOptions,
              "track-by": "id",
              "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
              "searchable": false,
              "selectedLabel": "",
              "selectLabel": "",
              "deselectLabel": ""
            },
            on: {
              "input": function($event) {
                _vm.set_room_type($event, cell.row)
              }
            },
            model: {
              value: (cell.row['type']),
              callback: function($$v) {
                var $$exp = cell.row,
                  $$idx = 'type';
                if (!Array.isArray($$exp)) {
                  cell.row['type'] = $$v
                } else {
                  $$exp.splice($$idx, 1, $$v)
                }
              },
              expression: "cell.row['type']"
            }
          })], 1)]
        }
      }])
    }, [_vm._l((_vm.room_table.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    }), _vm._v(" "), _c('datatable-column', {
      attrs: {
        "id": "actions-rooms",
        "label": _vm.actions_text,
        "width": "160px",
        "sortable": false,
        "groupable": false
      }
    })], 2)], 1)])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Bedrooms_and_bathrooms')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Bathrooms_number')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.bathrooms_number),
        expression: "appraisal.bathrooms_number"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.bathrooms_number)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.bathrooms_number = $event.target.value
        }, _vm.set_appraisal_bathrooms_number],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Bedrooms_number')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.bedrooms_number),
        expression: "appraisal.bedrooms_number"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.bedrooms_number)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.bedrooms_number = $event.target.value
        }, _vm.set_appraisal_bedrooms_number],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Enclosed_area')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Enclosed_checked_area')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.enclosed_checked_area),
        expression: "appraisal.enclosed_checked_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.enclosed_checked_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.enclosed_checked_area = $event.target.value
        }, _vm.set_appraisal_enclosed_checked_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field-group"
    }, [(!this.appraisal.enclosed_checked_area || this.appraisal.enclosed_checked_area < this.appraisal.net_checked_area) ? _c('div', [_c('message', {
      attrs: {
        "text": _vm.enclosed_checked_area_error_text,
        "icon_name": "exclamation",
        "icon_color": "darkred",
        "border_color": "red",
        "text_color": "darkred"
      }
    })], 1) : _vm._e()])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Proportional_part_of_common_elements')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Common_elements_cadastral_area')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.common_elements_cadastral_area),
        expression: "appraisal.common_elements_cadastral_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.common_elements_cadastral_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.common_elements_cadastral_area = $event.target.value
        }, _vm.set_appraisal_common_elements_cadastral_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Common_elements_registry_area')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.common_elements_registry_area),
        expression: "appraisal.common_elements_registry_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.common_elements_registry_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.common_elements_registry_area = $event.target.value
        }, _vm.set_appraisal_common_elements_registry_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Common_elements_checked_area')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.common_elements_checked_area),
        expression: "appraisal.common_elements_checked_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.common_elements_checked_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.common_elements_checked_area = $event.target.value
        }, _vm.set_appraisal_common_elements_checked_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Covered_outdoor_areas')))]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onCreateNewCoveredOutdoor($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus-circle",
        "text": _vm.new_covered_outdoor_button_text,
        "icon_color": "black",
        "text_color": _vm.editing_covered_outdoor_text_color,
        "disabled": _vm.editing_covered_outdoor,
        "border_color": _vm.editing_covered_outdoor_border_color
      }
    })], 1)]), _vm._v(" "), _c('div', {}, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "covered-outdoor-table-main",
        "source": _vm.object_to_array(_vm.appraisal_covered_outdoors),
        "filterable": false,
        "striped": _vm.covered_outdoor_table.striped,
        "editable": _vm.covered_outdoor_table.editable,
        "line-numbers": _vm.covered_outdoor_table.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "actions-covered-outdoors",
        fn: function(cell) {
          return [_c('table', {
            staticClass: "actions-table"
          }, [_c('tr', [_c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.delete_text
            },
            on: {
              "click": function($event) {
                _vm.deleteCoveredOutdoor(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "trash-o",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)])])])]
        }
      }, {
        key: "netarea",
        fn: function(cell) {
          return [_c('div', {}, [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (cell.row['netarea']),
              expression: "cell.row['netarea']"
            }],
            attrs: {
              "type": "number",
              "min": "0"
            },
            domProps: {
              "value": (cell.row['netarea'])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                var $$exp = cell.row,
                  $$idx = 'netarea';
                if (!Array.isArray($$exp)) {
                  cell.row['netarea'] = $event.target.value
                } else {
                  $$exp.splice($$idx, 1, $event.target.value)
                }
              }, function($event) {
                _vm.set_covered_outdoor_netarea($event, cell.row)
              }],
              "blur": function($event) {
                _vm.$forceUpdate()
              }
            }
          })])]
        }
      }, {
        key: "description",
        fn: function(cell) {
          return [_c('div', {}, [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (cell.row['description']),
              expression: "cell.row['description']"
            }],
            attrs: {
              "type": "text"
            },
            domProps: {
              "value": (cell.row['description'])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                var $$exp = cell.row,
                  $$idx = 'description';
                if (!Array.isArray($$exp)) {
                  cell.row['description'] = $event.target.value
                } else {
                  $$exp.splice($$idx, 1, $event.target.value)
                }
              }, function($event) {
                _vm.set_covered_outdoor_description($event, cell.row)
              }]
            }
          })])]
        }
      }, {
        key: "type",
        fn: function(cell) {
          return [_c('div', [_c('multiselect', {
            attrs: {
              "placeholder": "",
              "value": _vm.covered_outdoor_typeValue,
              "options": _vm.covered_outdoor_typeOptions,
              "track-by": "id",
              "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
              "searchable": false,
              "selectedLabel": "",
              "selectLabel": "",
              "deselectLabel": ""
            },
            on: {
              "input": function($event) {
                _vm.set_covered_outdoor_type($event, cell.row)
              }
            },
            model: {
              value: (cell.row['type']),
              callback: function($$v) {
                var $$exp = cell.row,
                  $$idx = 'type';
                if (!Array.isArray($$exp)) {
                  cell.row['type'] = $$v
                } else {
                  $$exp.splice($$idx, 1, $$v)
                }
              },
              expression: "cell.row['type']"
            }
          })], 1)]
        }
      }])
    }, [_vm._l((_vm.covered_outdoor_table.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    }), _vm._v(" "), _c('datatable-column', {
      attrs: {
        "id": "actions-covered-outdoors",
        "label": _vm.actions_text,
        "width": "160px",
        "sortable": false,
        "groupable": false
      }
    })], 2)], 1)])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Uncovered_outdoor_areas')))]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onCreateNewUncoveredOutdoor($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus-circle",
        "text": _vm.new_uncovered_outdoor_button_text,
        "icon_color": "black",
        "text_color": _vm.editing_uncovered_outdoor_text_color,
        "disabled": _vm.editing_uncovered_outdoor,
        "border_color": _vm.editing_uncovered_outdoor_border_color
      }
    })], 1)]), _vm._v(" "), _c('div', {}, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "uncovered-outdoor-table-main",
        "source": _vm.object_to_array(_vm.appraisal_uncovered_outdoors),
        "filterable": false,
        "striped": _vm.uncovered_outdoor_table.striped,
        "editable": _vm.uncovered_outdoor_table.editable,
        "line-numbers": _vm.uncovered_outdoor_table.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "actions-uncovered-outdoors",
        fn: function(cell) {
          return [_c('table', {
            staticClass: "actions-table"
          }, [_c('tr', [_c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.delete_text
            },
            on: {
              "click": function($event) {
                _vm.deleteUncoveredOutdoor(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "trash-o",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)])])])]
        }
      }, {
        key: "netarea",
        fn: function(cell) {
          return [_c('div', {}, [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (cell.row['netarea']),
              expression: "cell.row['netarea']"
            }],
            attrs: {
              "type": "number",
              "min": "0"
            },
            domProps: {
              "value": (cell.row['netarea'])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                var $$exp = cell.row,
                  $$idx = 'netarea';
                if (!Array.isArray($$exp)) {
                  cell.row['netarea'] = $event.target.value
                } else {
                  $$exp.splice($$idx, 1, $event.target.value)
                }
              }, function($event) {
                _vm.set_uncovered_outdoor_netarea($event, cell.row)
              }],
              "blur": function($event) {
                _vm.$forceUpdate()
              }
            }
          })])]
        }
      }, {
        key: "description",
        fn: function(cell) {
          return [_c('div', {}, [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (cell.row['description']),
              expression: "cell.row['description']"
            }],
            attrs: {
              "type": "text"
            },
            domProps: {
              "value": (cell.row['description'])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                var $$exp = cell.row,
                  $$idx = 'description';
                if (!Array.isArray($$exp)) {
                  cell.row['description'] = $event.target.value
                } else {
                  $$exp.splice($$idx, 1, $event.target.value)
                }
              }, function($event) {
                _vm.set_uncovered_outdoor_description($event, cell.row)
              }]
            }
          })])]
        }
      }, {
        key: "type",
        fn: function(cell) {
          return [_c('div', [_c('multiselect', {
            attrs: {
              "placeholder": "",
              "value": _vm.uncovered_outdoor_typeValue,
              "options": _vm.uncovered_outdoor_typeOptions,
              "track-by": "id",
              "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
              "searchable": false,
              "selectedLabel": "",
              "selectLabel": "",
              "deselectLabel": ""
            },
            on: {
              "input": function($event) {
                _vm.set_uncovered_outdoor_type($event, cell.row)
              }
            },
            model: {
              value: (cell.row['type']),
              callback: function($$v) {
                var $$exp = cell.row,
                  $$idx = 'type';
                if (!Array.isArray($$exp)) {
                  cell.row['type'] = $$v
                } else {
                  $$exp.splice($$idx, 1, $$v)
                }
              },
              expression: "cell.row['type']"
            }
          })], 1)]
        }
      }])
    }, [_vm._l((_vm.uncovered_outdoor_table.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    }), _vm._v(" "), _c('datatable-column', {
      attrs: {
        "id": "actions-uncovered-outdoors",
        "label": _vm.actions_text,
        "width": "160px",
        "sortable": false,
        "groupable": false
      }
    })], 2)], 1)])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Total_areas_summary_table')))]), _vm._v(" "), _c('div', {
      staticClass: "calc_table"
    }, [_c('table', {
      staticClass: "table-striped",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', {
      staticStyle: {
        "min-width": "120px",
        "text-align": "right"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.$t('Registry')) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "min-width": "120px"
      }
    }, [_vm._v(_vm._s(_vm.$t('Cadaster')))]), _vm._v(" "), _c('th', {
      staticStyle: {
        "min-width": "120px"
      }
    }, [_vm._v(_vm._s(_vm.$t('Checked')))]), _vm._v(" "), _c('th', {
      staticStyle: {
        "min-width": "300px"
      }
    }, [_vm._v(_vm._s(_vm.$t('Selected')))]), _vm._v(" "), _c('th', {
      staticStyle: {
        "min-width": "120px"
      }
    }, [_vm._v(_vm._s(_vm.$t('Adopted')))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.$t('Net_area')))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.net_registry_area)) + " m²")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.net_cadastral_area)) + " m²\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.net_checked_area)) + " m²")]), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.net_selected_areaValue,
        "options": _vm.selected_areaOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_net_selected_area
      },
      model: {
        value: (_vm.appraisal.net_selected_area),
        callback: function($$v) {
          _vm.appraisal.net_selected_area = $$v
        },
        expression: "appraisal.net_selected_area"
      }
    })], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.net_adopted_area)) + " m²")])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.$t('Enclosed_area')) + " (A)")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.enclosed_registry_area)) + " m²\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.enclosed_cadastral_area)) + " m²\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.enclosed_checked_area)) + " m²\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.enclosed_selected_areaValue,
        "options": _vm.selected_areaOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_enclosed_selected_area
      },
      model: {
        value: (_vm.appraisal.enclosed_selected_area),
        callback: function($$v) {
          _vm.appraisal.enclosed_selected_area = $$v
        },
        expression: "appraisal.enclosed_selected_area"
      }
    })], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.enclosed_adopted_area)) + " m²\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.$t('Covered_outdoor_area')) + " (B)")])]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("formatNumber")(_vm.appraisal.covered_terraces_total_registry_area)) + " m²\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("formatNumber")(_vm.appraisal.covered_terraces_total_cadastral_area)) + " m²\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("formatNumber")(_vm.appraisal.covered_terraces_total_checked_area)) + " m²\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.covered_outdoors_selected_areaValue,
        "options": _vm.selected_areaOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_covered_outdoors_selected_area
      },
      model: {
        value: (_vm.appraisal.covered_outdoors_selected_area),
        callback: function($$v) {
          _vm.appraisal.covered_outdoors_selected_area = $$v
        },
        expression: "appraisal.covered_outdoors_selected_area"
      }
    })], 1), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("formatNumber")(_vm.appraisal.covered_terraces_total_adopted_area)) + " m²\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.$t('Built_area')) + " ( (A+B) / 2 )")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.built_registry_area)) + " m²\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.built_cadastral_area)) + " m²\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.built_checked_area)) + " m²\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.built_selected_areaValue,
        "options": _vm.selected_areaOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_built_selected_area
      },
      model: {
        value: (_vm.appraisal.built_selected_area),
        callback: function($$v) {
          _vm.appraisal.built_selected_area = $$v
        },
        expression: "appraisal.built_selected_area"
      }
    })], 1), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.built_adopted_area)) + " m²")])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.$t('Common_elements')))])]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("formatNumber")(_vm.appraisal.common_elements_registry_area)) + " m²\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("formatNumber")(_vm.appraisal.common_elements_cadastral_area)) + " m²\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("formatNumber")(_vm.appraisal.common_elements_checked_area)) + " m²\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.common_elements_selected_areaValue,
        "options": _vm.selected_areaOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_common_elements_selected_area
      },
      model: {
        value: (_vm.appraisal.common_elements_selected_area),
        callback: function($$v) {
          _vm.appraisal.common_elements_selected_area = $$v
        },
        expression: "appraisal.common_elements_selected_area"
      }
    })], 1), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("formatNumber")(_vm.appraisal.common_elements_adopted_area)) + " m²\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.$t('Built_plus_common_elements')))])]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("formatNumber")(_vm.appraisal.built_plus_common_elements_registry_area)) + " m²\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("formatNumber")(_vm.appraisal.built_plus_common_elements_cadastral_area)) + " m²\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("formatNumber")(_vm.appraisal.built_plus_common_elements_checked_area)) + " m²\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.built_plus_common_elements_selected_areaValue,
        "options": _vm.selected_areaOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_built_plus_common_elements_selected_area
      },
      model: {
        value: (_vm.appraisal.built_plus_common_elements_selected_area),
        callback: function($$v) {
          _vm.appraisal.built_plus_common_elements_selected_area = $$v
        },
        expression: "appraisal.built_plus_common_elements_selected_area"
      }
    })], 1), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("formatNumber")(_vm.appraisal.built_plus_common_elements_adopted_area)) + " m²\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])])])])])])])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.cession_and_rights_text
      }
    }, [(_vm.currentLocale === 'ca') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Cessió, drets i protecció')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.cession_and_rights_text) + "\n\t\t\t\t\t\t\t")]) : (_vm.currentLocale === 'en') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Cession, rights and protection')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.cession_and_rights_text) + "\n\t\t\t\t\t\t\t")]) : _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Cessión, derechos y protección')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.cession_and_rights_text) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Occupancy')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Property_title')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.property_title),
        expression: "appraisal.property_title"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.property_title)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.property_title = $event.target.value
        }, _vm.set_appraisal_property_title]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Occupancy_status')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.occupancy_statusValue,
        "options": _vm.occupancy_statusOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_occupancy_status
      },
      model: {
        value: (_vm.appraisal.occupancy_status),
        callback: function($$v) {
          _vm.appraisal.occupancy_status = $$v
        },
        expression: "appraisal.occupancy_status"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Usage_assigned')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.usage_assigned),
        expression: "appraisal.usage_assigned"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.usage_assigned)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.usage_assigned = $event.target.value
        }, _vm.set_appraisal_usage_assigned]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field-group"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Property_usage')) + " (BdE)")]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.usage_typeBdEValue,
        "options": _vm.usage_typeBdEOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_usage_type
      },
      model: {
        value: (_vm.appraisal.usage_type),
        callback: function($$v) {
          _vm.appraisal.usage_type = $$v
        },
        expression: "appraisal.usage_type"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Inspection_realized')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.inspection_realized),
        expression: "appraisal.inspection_realized"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.inspection_realized)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.inspection_realized = $event.target.value
        }, _vm.set_appraisal_inspection_realized]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Economical_activity')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.economical_activity),
        expression: "appraisal.economical_activity"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.economical_activity)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.economical_activity = $event.target.value
        }, _vm.set_appraisal_economical_activity]
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "form-section"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Lease')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Is_it_rented_or_ceded_q')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.cession_boolean),
        expression: "appraisal.cession_boolean"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.cession_boolean) ? _vm._i(_vm.appraisal.cession_boolean, null) > -1 : (_vm.appraisal.cession_boolean)
      },
      on: {
        "click": _vm.set_appraisal_cession_boolean,
        "__c": function($event) {
          var $$a = _vm.appraisal.cession_boolean,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.cession_boolean = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.cession_boolean = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.cession_boolean = $$c
          }
        }
      }
    })])]), _vm._v(" "), (_vm.appraisal.cession_boolean) ? _c('div', [_c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Cession_contract_start_date')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.cession_contract_start_date),
        expression: "appraisal.cession_contract_start_date"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "date",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.cession_contract_start_date)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.cession_contract_start_date = $event.target.value
        }, _vm.set_appraisal_cession_contract_start_date]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Cession_contract_period_years')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.cession_contract_period_years),
        expression: "appraisal.cession_contract_period_years"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.cession_contract_period_years)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.cession_contract_period_years = $event.target.value
        }, _vm.set_appraisal_cession_contract_period_years],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Cession_contract_remaining_years')) + " (" + _vm._s(_vm.$t('acc_appraisal_date')) + ")")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.appraisal.cession_contract_remaining_years) + " " + _vm._s(_vm.$t('years')))])])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Cession_gross_monthly_income')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.cession_gross_monthly_income),
        expression: "appraisal.cession_gross_monthly_income"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.cession_gross_monthly_income)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.cession_gross_monthly_income = $event.target.value
        }, _vm.set_appraisal_cession_gross_monthly_income],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Cession_gross_yearly_income')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.cession_gross_yearly_income),
        expression: "appraisal.cession_gross_yearly_income"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.cession_gross_yearly_income)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.cession_gross_yearly_income = $event.target.value
        }, _vm.set_appraisal_cession_gross_yearly_income],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Landlord_expenses_pct')) + " (%)")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.landlord_expenses_pct),
        expression: "appraisal.landlord_expenses_pct"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.landlord_expenses_pct)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.landlord_expenses_pct = $event.target.value
        }, _vm.set_appraisal_landlord_expenses_pct],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Cession_net_yearly_income')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.cession_net_yearly_income)) + " €")])])]), _vm._v(" "), _c('div', {
      staticClass: "fiel-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Cession_gross_monthly_income_by_contract')))])])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Tenant_age_years')) + " (" + _vm._s(_vm.$t('years')) + ")")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.tenant_age_years),
        expression: "appraisal.tenant_age_years"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.tenant_age_years)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.tenant_age_years = $event.target.value
        }, _vm.set_appraisal_tenant_age_years],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Tenant_life_expectancy_years')) + " (" + _vm._s(_vm.$t('years')) + ")")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.tenant_life_expectancy_years),
        expression: "appraisal.tenant_life_expectancy_years"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.tenant_life_expectancy_years)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.tenant_life_expectancy_years = $event.target.value
        }, _vm.set_appraisal_tenant_life_expectancy_years],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Tenant_remaining_life_expectancy_years')) + " (" + _vm._s(_vm.$t('years')) + ")")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.appraisal.tenant_remaining_life_expectancy_years) + " " + _vm._s(_vm.$t('years')))])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "form-section"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Right_of_use')) + " " + _vm._s(_vm.$t('and')) + " " + _vm._s(_vm.$t('Bare_ownership')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Is_the_right_of_use_ceded_q')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.right_of_use_boolean),
        expression: "appraisal.right_of_use_boolean"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.right_of_use_boolean) ? _vm._i(_vm.appraisal.right_of_use_boolean, null) > -1 : (_vm.appraisal.right_of_use_boolean)
      },
      on: {
        "click": _vm.set_appraisal_right_of_use_boolean,
        "__c": function($event) {
          var $$a = _vm.appraisal.right_of_use_boolean,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.right_of_use_boolean = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.right_of_use_boolean = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.right_of_use_boolean = $$c
          }
        }
      }
    })])]), _vm._v(" "), (_vm.appraisal.right_of_use_boolean) ? _c('div', [_c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Usufructuary_age_years')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.usufructuary_age_years),
        expression: "appraisal.usufructuary_age_years"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.usufructuary_age_years)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.usufructuary_age_years = $event.target.value
        }, _vm.set_appraisal_usufructuary_age_years],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "form-section"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Protection_regime')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Is_the_real_estate_protected_q')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.protection_boolean),
        expression: "appraisal.protection_boolean"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.protection_boolean) ? _vm._i(_vm.appraisal.protection_boolean, null) > -1 : (_vm.appraisal.protection_boolean)
      },
      on: {
        "click": _vm.set_appraisal_protection_boolean,
        "__c": function($event) {
          var $$a = _vm.appraisal.protection_boolean,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.protection_boolean = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.protection_boolean = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.protection_boolean = $$c
          }
        }
      }
    })])]), _vm._v(" "), (_vm.appraisal.protection_boolean) ? _c('div', [_c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Protection_type')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.protection_typeValue,
        "options": _vm.protection_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_protection_type
      },
      model: {
        value: (_vm.appraisal.protection_type),
        callback: function($$v) {
          _vm.appraisal.protection_type = $$v
        },
        expression: "appraisal.protection_type"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Protection_regime')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.protection_regimeValue,
        "options": _vm.protection_regimeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_protection_regime
      },
      model: {
        value: (_vm.appraisal.protection_regime),
        callback: function($$v) {
          _vm.appraisal.protection_regime = $$v
        },
        expression: "appraisal.protection_regime"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Protection_zone')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.protection_zoneValue,
        "options": _vm.protection_zoneOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_protection_zone
      },
      model: {
        value: (_vm.appraisal.protection_zone),
        callback: function($$v) {
          _vm.appraisal.protection_zone = $$v
        },
        expression: "appraisal.protection_zone"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Maximum_legal_sale_price')) + " (€/m²)")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.max_legal_price),
        expression: "appraisal.max_legal_price"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.max_legal_price)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.max_legal_price = $event.target.value
        }, _vm.set_appraisal_max_legal_price],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Maximum_legal_computable_area')) + " (m²)")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.max_legal_area),
        expression: "appraisal.max_legal_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.max_legal_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.max_legal_area = $event.target.value
        }, _vm.set_appraisal_max_legal_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]) : _vm._e()])])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.Market_text
      }
    }, [(_vm.currentLocale === 'ca') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Mercat')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.Market_text) + "\n\t\t\t\t\t\t\t")]) : (_vm.currentLocale === 'en') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Market')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.Market_text) + "\n\t\t\t\t\t\t\t")]) : _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Mercado')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.Market_text) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Market_study')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Select')) + " " + _vm._s(_vm.$t('a')) + " " + _vm._s(_vm.$t('Market_study')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.marketstudy_idValue,
        "options": this.object_to_array(_vm.realestate_marketstudies),
        "track-by": "id",
        "label": 'id',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_marketstudy_id
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v("Id")]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.appraisal.marketstudy_id) + " ")])]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Market_value')))]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm._f("formatNumber")(_vm.appraisal.market_value)) + " € ")])]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Market_unit_value')))]), _vm._v(" "), _c('strong', [_c('span', [_vm._v(" " + _vm._s(_vm._f("formatNumber")(_vm.appraisal.market_unit_value)) + " €/m² ")])])])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('button', {
      staticClass: "quote-request__aux__button",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onOpenMarketStudy($event)
        },
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          _vm.onOpenMarketStudy($event)
        }
      }
    }, [_c('span', [_c('icon', {
      attrs: {
        "name": "external-link",
        "scale": "1",
        "color": "rgb(0, 79, 146)"
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Edit')) + " " + _vm._s(_vm.$t('Market_study')))], 1)])])])])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.technical_values_text
      }
    }, [(_vm.currentLocale === 'ca') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Valors tècnics')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.technical_values_text) + "\n\t\t\t\t\t\t\t")]) : (_vm.currentLocale === 'en') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Technical values')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.technical_values_text) + "\n\t\t\t\t\t\t\t")]) : _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Valores técnicos')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.technical_values_text))]), _vm._v(" "), _c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Construction_cost_by_contract')))]), _vm._v(" "), _c('table', {
      staticClass: "table-striped calc"
    }, [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Adjusted_bec_price')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.adjusted_bec_price))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('BEC_expenses_plus_builders_benefit_pct')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.expenses_and_industrial_benefit_bec_pct) + " %")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Material_execution_cost_as_new')))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm._f("formatNumber")(_vm.appraisal.material_execution_cost)) + " €/m²\n\t\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Mec_adjustment_coef')))]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.mec_adjustment_coef),
        expression: "appraisal.mec_adjustment_coef"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "step": "0.05",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.mec_adjustment_coef)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.mec_adjustment_coef = $event.target.value
        }, _vm.set_appraisal_mec_adjustment_coef],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Adopted_material_execution_cost')))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm._f("formatNumber")(_vm.appraisal.adopted_material_execution_cost)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Integrity')) + " " + _vm._s(_vm.$t('or')) + " " + _vm._s(_vm.$t('remaining')) + " " + _vm._s(_vm.$t('of')) + " " + _vm._s(_vm.$t('Depreciation_by_antiquity')) + " (da = 100 - d)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.total_depreciation_pct) + " %")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Adopted_material_execution_cost_deprecated_by_antiquity')) + " (Cem))\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.deprecated_material_execution_cost)) + " €/m²\n\t\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Builders_industrial_benefit_percentage')))]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.bc_pct),
        expression: "appraisal.bc_pct"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.bc_pct)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.bc_pct = $event.target.value
        }, _vm.set_appraisal_bc_pct],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    }), _vm._v(" %")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Builders_industrial_benefit')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.bc)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Builders_general_expenses_percentage')) + " (% Gc)")]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.gc_pct),
        expression: "appraisal.gc_pct"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.gc_pct)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.gc_pct = $event.target.value
        }, _vm.set_appraisal_gc_pct],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    }), _vm._v(" %")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Builders_general_expenses')) + " (Gc) ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.gc)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Builders_expenses_and_benefit_percentage')) + " (% Bc + % Gc)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.bc_and_gc_pct) + " %")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Builders_expenses_and_benefit')) + " (Bc + Gc) ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.bc_and_gc)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v(_vm._s(_vm.$t('Construction_costs')) + " (Cc = Cem + Bc + Gc) ")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.cc)) + " €/m²")])])])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Development_expenses')))]), _vm._v(" "), _c('table', {
      staticClass: "table-striped calc"
    }, [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Honorarium_c_taxes_and_licenses_percentage')) + " (% HTL)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.htl_pct) + " %")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Honorarium_c_taxes_and_licenses')) + " (HTL)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.htl)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Non_recoverable_taxes_percentage')) + " % Impostos no recuperables (% INR)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.inr_pct) + " %")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Non_recoverable_taxes')) + " Impostos no recuperables (INR)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.inr)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Developers_administrative_expenses_percentage')) + " (% Ga)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.ga_pct) + " %")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Developers_administrative_expenses')) + " (Ga)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.ga)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Decennial_insurance_policy_expenses_percentage')) + " (% Gpd)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.gpd_pct) + " %")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Decennial_insurance_policy_expenses')) + " (Gpd)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.gpd)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("% OCT")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.oct_pct) + " %")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("OCT")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.oct)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Development_expenses_percentage')) + " (% Gp = % HTL + % INR + % Ga + % Gpd + % OCT)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.gp_pct) + " %")])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v(_vm._s(_vm.$t('Development_expenses')) + " (Gp = HTL + INR + Ga + Gpd + OCT)")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.gp)) + " €/m²")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Construction_costs')) + " (Cc)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.cc)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v(_vm._s(_vm.$t('Construction_replacement_cost')) + " (Cc + Gp)")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.cc_and_gp)) + " €/m²")])])])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Developers_benefit')))]), _vm._v(" "), _c('table', {
      staticClass: "table-striped calc"
    }, [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Riskfree_rate')) + " (TLR)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.tlr_pct) + " %")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Risk_premium')) + " (PR)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.pr_pct) + " %")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Agravation_or_improvement_coeficient')) + " (Coef. AM)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.am_coef))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Freemarket_benefit')) + " (b1 = (TLR + PR) * Coef. AM )\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.b1_pct) + " %")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Minimum_benefit_acc_to_regulation')) + " (b2)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.b2_pct) + " %")])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v(_vm._s(_vm.$t('Developers_benefit')) + "  (max: b1 vs b2)")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.appraisal.b_pct) + " %")])])])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Land_market_value')))]), _vm._v(" "), _c('table', {
      staticClass: "table-striped calc"
    }, [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Building_market_value')) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.market_unit_value)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Market_value_adjustment')) + " (%)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.market_value_appraiser_adjustment_pct),
        expression: "appraisal.market_value_appraiser_adjustment_pct"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.market_value_appraiser_adjustment_pct)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.market_value_appraiser_adjustment_pct = $event.target.value
        }, _vm.set_appraisal_market_value_appraiser_adjustment_pct],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    }), _vm._v(" %")])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v(_vm._s(_vm.$t('Adopted_building_market_value')) + " (VM)")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.adopted_market_unit_value)) + " €/m²")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Construction_costs')) + " (Cc)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.cc)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Development_expenses')) + " (Gp)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.gp)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Remaining_of_the_developers_benefit')) + " (1-b)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.b_remaining_pct) + " %")])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v(_vm._s(_vm.$t('Land_market_value')) + " ( F = Vm * (1-b) - (Cc + Gp) )")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.f)) + " €/m²")])])])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v("CRB: " + _vm._s(_vm.$t('Gross_Replacement_Cost')) + " (" + _vm._s(_vm.$t('finished_building')) + ")")]), _vm._v(" "), _c('table', {
      staticClass: "table-striped calc"
    }, [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Land_market_value')) + " (F)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.f)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('As_new_construction_cost')) + " (Ccb)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.ccb)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Development_expenses')) + " (Gpb)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.gpb)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v(_vm._s(_vm.$t('Gross_Replacement_Cost')) + " (CRB)")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.crb)) + " €/m²")])])])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v("CRN: " + _vm._s(_vm.$t('Net_Replacement_Cost')) + " (" + _vm._s(_vm.$t('finished_building')) + ")")]), _vm._v(" "), _c('table', {
      staticClass: "table-striped calc"
    }, [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Land_market_value')) + " (F)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.f)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('As_new_construction_cost')) + " (Ccb)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.ccb)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Development_expenses')) + " (Gpb)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.gpb)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Construction_cost_and_development_expenses')) + " (Ccb + Gpb)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.ccb_and_gpb)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Adopted_age')) + " (A)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.adopted_age_years_old) + " " + _vm._s(_vm.$t('years')) + " (" + _vm._s(_vm.appraisal.adopted_age) + ")\n\t\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Estimated_useful_life')) + " (V"), _c('sub', [_vm._v("u")]), _vm._v(")\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.useful_life_years) + " " + _vm._s(_vm.$t('years')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Physical_depreciation')) + " (DFI = A * V"), _c('sub', [_vm._v("u")]), _vm._v(")\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.physical_depreciation_pct) + " %")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Functional_depreciation')) + " (DFU)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.functional_depreciation_pct) + " %")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Total_depreciation')) + " (D = (1 - DFI) * (1 - DFU))\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.total_depreciation_pct) + " %")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Deprecated_construction_cost')) + " (CCD = (Ccb + Gpb) * D)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.ccd)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Developers_administrative_expenses')) + " (Ga)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.ga)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Land_value_plus_deprecated_construction_cost')) + " (F + Ccd)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.deprecated_land_and_ccd)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("CRN: " + _vm._s(_vm.$t('Net_Replacement_Cost')) + " (" + _vm._s(_vm.$t('finished_building')) + ")")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.finished_realestate_crn)) + " €/m²")])])])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v("CRN: " + _vm._s(_vm.$t('Net_Replacement_Cost')) + " (" + _vm._s(_vm.$t('real_estate_under_construction')) + ")")]), _vm._v(" "), _c('table', {
      staticClass: "table-striped calc"
    }, [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Land_market_value')) + " (F)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.f)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('As_new_construction_cost')) + " (Ccb)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.ccb)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Development_expenses')) + " (Gpb)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.gpb)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Construction_cost_and_development_expenses')) + " (Ccb + Gpb)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.ccb_and_gpb)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Construction_progress_percentage')) + " (%)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.total_construction_progress_pct),
        expression: "appraisal.total_construction_progress_pct"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "max": "100",
        "step": "1",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.total_construction_progress_pct)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.total_construction_progress_pct = $event.target.value
        }, _vm.set_appraisal_total_construction_progress_pct],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    }), _vm._v(" %\n\t\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Executed_construction_cost')) + " (Ccr)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.ccr)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Developers_administrative_expenses')) + " (" + _vm._s(_vm.$t('executed_construction')) + ") (Gar)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.gar)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Land_value_plus_executed_construction_cost')) + " (F + Ccr)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.executed_construction_cost)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("CRN: " + _vm._s(_vm.$t('Net_Replacement_Cost')) + " (" + _vm._s(_vm.$t('real_estate_under_construction')) + ") (F + Ccr + Gar)")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.under_construction_realestate_crn)) + " €/m²")])])])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Market_value')))]), _vm._v(" "), _c('table', {
      staticClass: "table-striped calc"
    }, [_c('tr', [_c('td', [_c('strong', [_vm._v(_vm._s(_vm.$t('Finished_building_market_value')) + " (VM)")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.adopted_market_unit_value)) + " €/m²")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Market_coeficient')) + " (K)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.k)))])])])])])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.total_values_text
      }
    }, [(_vm.currentLocale === 'ca') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Valors totals')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.total_values_text) + "\n\t\t\t\t\t\t\t")]) : (_vm.currentLocale === 'en') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Total values')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.total_values_text) + "\n\t\t\t\t\t\t\t")]) : _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Valores totales')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.total_values_text))]), _vm._v(" "), _c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Land_value')))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('Repercussion_method')))]), _vm._v(" "), _c('table', {
      staticClass: "table-striped calc"
    }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Built_area')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Unit_value')) + " (f)")]), _vm._v(" "), _c('th', [_vm._v(" " + _vm._s(_vm.$t('Land_total_value')) + " " + _vm._s(_vm.$t('by')) + " " + _vm._s(_vm.$t('Repercussion_method')) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('tr', [_c('td', [(_vm.appraisal.property_type) ? _c('span', [(_vm.currentLocale == 'ca') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_ca))]) : (_vm.currentLocale == 'en') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_en))]) : _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_es))])]) : _vm._e(), (_vm.realestate.floor) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.floor))]) : _vm._e(), (_vm.realestate.door) ? _c('span', [_vm._v("-" + _vm._s(_vm.realestate.door))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.adopted_area)) + " m²")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm._f("formatNumber")(_vm.appraisal.f)) + " €/m²")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.repercussion_method_land_value)) + " €")])])])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Construction_value')))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('Cost_method')))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('Gross_Replacement_Cost')) + " (CRB)")]), _vm._v(" "), _c('table', {
      staticClass: "table-striped calc"
    }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Built_area')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Unit_value')) + " (Ccb + Gpb)")]), _vm._v(" "), _c('th', [_vm._v(" " + _vm._s(_vm.$t('Construction_value')) + " (CRB)")])]), _vm._v(" "), _c('tr', [_c('td', [(_vm.appraisal.property_type) ? _c('span', [(_vm.currentLocale == 'ca') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_ca))]) : (_vm.currentLocale == 'en') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_en))]) : _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_es))])]) : _vm._e(), (_vm.realestate.floor) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.floor))]) : _vm._e(), (_vm.realestate.door) ? _c('span', [_vm._v("-" + _vm._s(_vm.realestate.door))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.adopted_area)) + " m²")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm._f("formatNumber")(_vm.appraisal.ccb_and_gpb)) + " €/m²")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.cost_method_construction_crb_value)) + " €")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('Net_Replacement_Cost')) + " (CRN)")]), _vm._v(" "), _c('table', {
      staticClass: "table-striped calc"
    }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Built_area')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Unit_value')) + " " + _vm._s(_vm.$t('Deprecated_construction_cost')) + "  (Ccd)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('th', [_vm._v(" " + _vm._s(_vm.$t('Construction_value')) + " (CRN)")])]), _vm._v(" "), _c('tr', [_c('td', [(_vm.appraisal.property_type) ? _c('span', [(_vm.currentLocale == 'ca') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_ca))]) : (_vm.currentLocale == 'en') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_en))]) : _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_es))])]) : _vm._e(), (_vm.realestate.floor) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.floor))]) : _vm._e(), (_vm.realestate.door) ? _c('span', [_vm._v("-" + _vm._s(_vm.realestate.door))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.adopted_area)) + " m²")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm._f("formatNumber")(_vm.appraisal.ccd)) + " €/m²")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.cost_method_construction_crn_value)) + " €")])])])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Real_estate_value')) + " (" + _vm._s(_vm.$t('Construction')) + " + " + _vm._s(_vm.$t('Land')) + ")")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('Cost_method')))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('Gross_Replacement_Cost')) + " (CRB)")]), _vm._v(" "), _c('table', {
      staticClass: "table-striped calc"
    }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Built_area')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Unit_value')) + " " + _vm._s(_vm.$t('Gross_Replacement_Cost')) + " (CRB)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('th', [_vm._v(" " + _vm._s(_vm.$t('Real_estate_value')) + " (CRB)")])]), _vm._v(" "), _c('tr', [_c('td', [(_vm.appraisal.property_type) ? _c('span', [(_vm.currentLocale == 'ca') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_ca))]) : (_vm.currentLocale == 'en') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_en))]) : _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_es))])]) : _vm._e(), (_vm.realestate.floor) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.floor))]) : _vm._e(), (_vm.realestate.door) ? _c('span', [_vm._v("-" + _vm._s(_vm.realestate.door))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.adopted_area)) + " m²")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm._f("formatNumber")(_vm.appraisal.crb)) + " €/m²")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.cost_method_realestate_crb_value)) + " €")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('Net_Replacement_Cost')) + " (CRN) (" + _vm._s(_vm.$t('finished_building')) + ")")]), _vm._v(" "), _c('table', {
      staticClass: "table-striped calc"
    }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Built_area')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Unit_value')) + " " + _vm._s(_vm.$t('Net_Replacement_Cost')) + "  (CRN)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('th', [_vm._v(" " + _vm._s(_vm.$t('Real_estate_value')) + " (CRN)")])]), _vm._v(" "), _c('tr', [_c('td', [(_vm.appraisal.property_type) ? _c('span', [(_vm.currentLocale == 'ca') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_ca))]) : (_vm.currentLocale == 'en') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_en))]) : _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_es))])]) : _vm._e(), (_vm.realestate.floor) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.floor))]) : _vm._e(), (_vm.realestate.door) ? _c('span', [_vm._v("-" + _vm._s(_vm.realestate.door))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.adopted_area)) + " m²")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.finished_realestate_crn)) + " €/m²")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.cost_method_realestate_crn_value)) + " €")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.appraisal.total_construction_progress_pct < 100) ? _c('h4', [_vm._v(_vm._s(_vm.$t('Net_Replacement_Cost')) + " (CRN) (" + _vm._s(_vm.$t('real_estate_under_construction')) + ")")]) : _vm._e(), _vm._v(" "), (_vm.appraisal.total_construction_progress_pct < 100) ? _c('table', {
      staticClass: "table-striped calc"
    }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Built_area')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Unit_value')) + " " + _vm._s(_vm.$t('Net_Replacement_Cost')) + "  (CRN)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('th', [_vm._v(" " + _vm._s(_vm.$t('Real_estate_value')) + " (CRN)")])]), _vm._v(" "), _c('tr', [_c('td', [(_vm.appraisal.property_type) ? _c('span', [(_vm.currentLocale == 'ca') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_ca))]) : (_vm.currentLocale == 'en') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_en))]) : _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_es))])]) : _vm._e(), (_vm.realestate.floor) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.floor))]) : _vm._e(), (_vm.realestate.door) ? _c('span', [_vm._v("-" + _vm._s(_vm.realestate.door))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.adopted_area)) + " m²")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.under_construction_realestate_crn)) + " €/m²")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.cost_method_unfinished_realestate_crn_value)) + " €")])])])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('Comparison_Method')))]), _vm._v(" "), _c('table', {
      staticClass: "table-striped calc"
    }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Built_area')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Unit_value')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Real_estate_value')) + " " + _vm._s(_vm.$t('by')) + " " + _vm._s(_vm.$t('Comparison_Method')) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('tr', [_c('td', [(_vm.appraisal.property_type) ? _c('span', [(_vm.currentLocale == 'ca') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_ca))]) : (_vm.currentLocale == 'en') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_en))]) : _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_es))])]) : _vm._e(), (_vm.realestate.floor) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.floor))]) : _vm._e(), (_vm.realestate.door) ? _c('span', [_vm._v("-" + _vm._s(_vm.realestate.door))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.adopted_area)) + " m²")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.adopted_market_unit_value)) + " €/m²\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.comparison_method)) + " €")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('Maximum_Legal_Method')))]), _vm._v(" "), (this.appraisal.protection_boolean) ? _c('div', [_c('table', {
      staticClass: "table-striped calc"
    }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Maximum_legal_computable_area')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Maximum_legal_sale_price')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Real_estate_value')) + " " + _vm._s(_vm.$t('by')) + " " + _vm._s(_vm.$t('Maximum_Legal_Method')) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('tr', [_c('td', [(_vm.appraisal.property_type) ? _c('span', [(_vm.currentLocale == 'ca') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_ca))]) : (_vm.currentLocale == 'en') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_en))]) : _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_es))])]) : _vm._e(), (_vm.realestate.floor) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.floor))]) : _vm._e(), (_vm.realestate.door) ? _c('span', [_vm._v("-" + _vm._s(_vm.realestate.door))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.max_legal_area)) + " m²")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.max_legal_price)) + " €/m²")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.max_legal_method)) + " €")])])])])]) : _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('The_Real_Estate_is_not_protected')) + ". " + _vm._s(_vm.$t('The_value_is_not_calculated')) + ".")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('Expected_Income_Update_Method')))]), _vm._v(" "), (this.appraisal.cession_boolean) ? _c('div', [_c('span', [_vm._v("(" + _vm._s(_vm.$t('Remaining_period_update')) + ". " + _vm._s(_vm.$t('Constant_income_with_CPI_update_clause')) + ")")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('Contracts_foreseeable_remaining_period')) + " (u)")]), _vm._v(" "), _c('table', {
      staticClass: "table-striped calc"
    }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Cession_contract_start_date')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Cession_contract_period_years')))]), _vm._v(" "), _c('th', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.$t('Cession_contract_remaining_years')) + " (" + _vm._s(_vm.$t('acc_appraisal_date')) + ") (n1)\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Realestates_remaining_useful_life')) + " (n2)")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Tenant_remaining_life_expectancy_years')) + " (n3)")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Contracts_foreseeable_remaining_period')) + " (min. n1/n2/n3)\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('tr', [_c('td', [(_vm.appraisal.property_type) ? _c('span', [(_vm.currentLocale == 'ca') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_ca))]) : (_vm.currentLocale == 'en') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_en))]) : _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_es))])]) : _vm._e(), (_vm.realestate.floor) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.floor))]) : _vm._e(), (_vm.realestate.door) ? _c('span', [_vm._v("-" + _vm._s(_vm.realestate.door))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.cession_contract_start_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.cession_contract_period_years) + " " + _vm._s(_vm.$t('years')) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.cession_contract_remaining_years) + " " + _vm._s(_vm.$t('years')) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.remaining_useful_life_years) + " " + _vm._s(_vm.$t('years')) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.appraisal.tenant_remaining_life_expectancy_years) + " " + _vm._s(_vm.$t('years')) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.u) + " " + _vm._s(_vm.$t('years')))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('Real_Estates_residual_value')))]), _vm._v(" "), _c('table', {
      staticClass: "table-striped calc"
    }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Market_value')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Construction_cost_by_contract')) + " (CRB-Constr.)")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Buildings_useful_life')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Remaining_contract_years')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Residual_depreciation')))]), _vm._v(" "), _c('th', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.$t('Real_estates_residual_value_at_the_end_of_the_contracts_useful_life')) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('tr', [_c('td', [(_vm.appraisal.property_type) ? _c('span', [(_vm.currentLocale == 'ca') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_ca))]) : (_vm.currentLocale == 'en') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_en))]) : _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_es))])]) : _vm._e(), (_vm.realestate.floor) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.floor))]) : _vm._e(), (_vm.realestate.door) ? _c('span', [_vm._v("-" + _vm._s(_vm.realestate.door))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.comparison_method)) + " €")]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("formatNumber")(_vm.appraisal.cost_method_construction_crb_value)) + " €\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.useful_life_years) + " " + _vm._s(_vm.$t('years')) + " ")]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.appraisal.u) + " " + _vm._s(_vm.$t('years')) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.residual_depreciation)) + " €")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.realestate_residual_value)) + " €\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('Current_value_of_future_rents')))]), _vm._v(" "), _c('table', {
      staticClass: "table-striped calc"
    }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Gross_yearly_rent_income')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Landlord_expenses_pct')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Net_yearly_rent_income')) + " (Rn)")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Remaining_contract_years')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Update_type')) + " (i) (%)")]), _vm._v(" "), _c('th', [_vm._v("Coef. 1: [(1 + i) ^ n - 1] / [(1 + i) ^ n * i]")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Current_value_of_future_rents')) + " (Rn * n * coef_1)\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('tr', [_c('td', [(_vm.appraisal.property_type) ? _c('span', [(_vm.currentLocale == 'ca') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_ca))]) : (_vm.currentLocale == 'en') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_en))]) : _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_es))])]) : _vm._e(), (_vm.realestate.floor) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.floor))]) : _vm._e(), (_vm.realestate.door) ? _c('span', [_vm._v("-" + _vm._s(_vm.realestate.door))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.cession_gross_yearly_income)) + " €\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.landlord_expenses_pct) + "%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.cession_net_yearly_income)) + " €\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.u) + " " + _vm._s(_vm.$t('years')) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.i_pct),
        expression: "appraisal.i_pct"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.i_pct)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.i_pct = $event.target.value
        }, _vm.set_appraisal_i_pct],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.coef_1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.current_future_income_value)) + " €\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('Current_reversion_value_calculation')))]), _vm._v(" "), _c('table', {
      staticClass: "table-striped calc"
    }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.$t('Real_estates_residual_value_at_the_end_of_the_contracts_useful_life')) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Remaining_contract_years')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Update_type')) + " (i) (%)")]), _vm._v(" "), _c('th', [_vm._v("Coef. 2: ((1 + i) ^ n )")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Updated_reversion_value')) + " (" + _vm._s(_vm.$t('Residual_value')) + "/ coef. 2)\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('tr', [_c('td', [(_vm.appraisal.property_type) ? _c('span', [(_vm.currentLocale == 'ca') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_ca))]) : (_vm.currentLocale == 'en') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_en))]) : _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_es))])]) : _vm._e(), (_vm.realestate.floor) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.floor))]) : _vm._e(), (_vm.realestate.door) ? _c('span', [_vm._v("-" + _vm._s(_vm.realestate.door))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.cession_gross_yearly_income)) + " €\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.u) + " " + _vm._s(_vm.$t('years')) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.i_pct),
        expression: "appraisal.i_pct"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.i_pct)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.i_pct = $event.target.value
        }, _vm.set_appraisal_i_pct],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.coef_2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.updated_reversion_value)) + " €\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('Update_value_calculation')))]), _vm._v(" "), _c('table', {
      staticClass: "table-striped calc"
    }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Current_value_of_future_rents')) + " (A)")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Updated_reversion_value')) + " (B)")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Update_value')) + " (A+B)")])]), _vm._v(" "), _c('tr', [_c('td', [(_vm.appraisal.property_type) ? _c('span', [(_vm.currentLocale == 'ca') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_ca))]) : (_vm.currentLocale == 'en') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_en))]) : _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_es))])]) : _vm._e(), (_vm.realestate.floor) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.floor))]) : _vm._e(), (_vm.realestate.door) ? _c('span', [_vm._v("-" + _vm._s(_vm.realestate.door))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.current_future_income_value)) + " €\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.updated_reversion_value)) + " €\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.update_value)) + " €")])])])]) : _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('The_Real_Estate_is_not_rented_or_ceded')) + ". " + _vm._s(_vm.$t('The_value_is_not_calculated')) + ".")])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Right_of_use_value')))]), _vm._v(" "), (this.appraisal.right_of_use_boolean) ? _c('div', [_c('table', {
      staticClass: "table-striped calc"
    }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Usufructuary_age_years')) + " (n)")]), _vm._v(" "), _c('th', [_vm._v("Coef. V"), _c('sub', [_vm._v("u")]), _vm._v(" (max: 10% vs. 0,7 - 0,01 * ( n - 20))\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Usufruct_value')) + " (VM * Coef. V"), _c('sub', [_vm._v("u")]), _vm._v(")")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Bare_ownership_value')) + " (VM * (1 - Coef. V"), _c('sub', [_vm._v("u")]), _vm._v("))\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('tr', [_c('td', [(_vm.appraisal.property_type) ? _c('span', [(_vm.currentLocale == 'ca') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_ca))]) : (_vm.currentLocale == 'en') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_en))]) : _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_es))])]) : _vm._e(), (_vm.realestate.floor) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.floor))]) : _vm._e(), (_vm.realestate.door) ? _c('span', [_vm._v("-" + _vm._s(_vm.realestate.door))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.usufructuary_age_years) + " " + _vm._s(_vm.$t('years')) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.vu_coef))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.usufruct_value)) + " €")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.bare_ownership_value)) + " €")])])])])]) : _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('There_is_no_cession_of_the_right_of_use')) + ". " + _vm._s(_vm.$t('The_value_is_not_calculated')) + ".")])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Insurance_value')) + " s/ R. D. 685/1982")]), _vm._v(" "), _c('table', {
      staticClass: "table-striped calc"
    }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Gross_Replacement_Cost')) + " (CRB)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "width": "50px"
      }
    }), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Land_value')))]), _vm._v(" "), _c('th', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "width": "50px"
      }
    }), _vm._v(" "), _c('th', [_vm._v(" Total ")])]), _vm._v(" "), _c('tr', [_c('td', [(_vm.appraisal.property_type) ? _c('span', [(_vm.currentLocale == 'ca') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_ca))]) : (_vm.currentLocale == 'en') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_en))]) : _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_es))])]) : _vm._e(), (_vm.realestate.floor) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.floor))]) : _vm._e(), (_vm.realestate.door) ? _c('span', [_vm._v("-" + _vm._s(_vm.realestate.door))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.cost_method_realestate_crb_value)) + " €")]), _vm._v(" "), _c('td', [_vm._v(" - ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm._f("formatNumber")(_vm.appraisal.repercussion_method_land_value)) + " €")]), _vm._v(" "), _c('td', [_vm._v(" = ")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.insurance_value_rd_685_1982)) + " €")])])])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Insurance_value')) + " s/ R. D. 246/1998, 716/2009")]), _vm._v(" "), _c('table', {
      staticClass: "table-striped calc"
    }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Appraisal_value')) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "width": "50px"
      }
    }), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Land_value')))]), _vm._v(" "), _c('th', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "width": "50px"
      }
    }), _vm._v(" "), _c('th', [_vm._v(" Total ")])]), _vm._v(" "), _c('tr', [_c('td', [(_vm.appraisal.property_type) ? _c('span', [(_vm.currentLocale == 'ca') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_ca))]) : (_vm.currentLocale == 'en') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_en))]) : _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_es))])]) : _vm._e(), (_vm.realestate.floor) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.floor))]) : _vm._e(), (_vm.realestate.door) ? _c('span', [_vm._v("-" + _vm._s(_vm.realestate.door))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.realestate_total_adopted_value)) + " €")]), _vm._v(" "), _c('td', [_vm._v(" - ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm._f("formatNumber")(_vm.appraisal.repercussion_method_land_value)) + " €")]), _vm._v(" "), _c('td', [_vm._v(" = ")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.insurance_value_rd_716_2009)) + " €")])])])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Appraisal_total_value_determination')))]), _vm._v(" "), _c('table', {
      staticClass: "table-striped calc"
    }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Comparison_Method')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Adjusted_Comparison_Method')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Maximum_Legal_Method')))]), _vm._v(" "), (_vm.appraisal.cession_boolean) ? _c('th', [_vm._v(_vm._s(_vm.$t('Expected_Income_Update_Method')))]) : _vm._e(), _vm._v(" "), (_vm.appraisal.total_construction_progress_pct < 100) ? _c('th', [_vm._v(_vm._s(_vm.$t('Net_Replacement_Cost')) + " (" + _vm._s(_vm.$t('real_estate_under_construction')) + ")")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Adopted_value')))])]), _vm._v(" "), _c('tr', [_c('td', [(_vm.appraisal.property_type) ? _c('span', [(_vm.currentLocale == 'ca') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_ca))]) : (_vm.currentLocale == 'en') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_en))]) : _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_es))])]) : _vm._e(), (_vm.realestate.floor) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.floor))]) : _vm._e(), (_vm.realestate.door) ? _c('span', [_vm._v("-" + _vm._s(_vm.realestate.door))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.comparison_method)) + " €")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.adjusted_market_value)) + " €")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.max_legal_method)) + " €")]), _vm._v(" "), (_vm.appraisal.cession_boolean) ? _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.update_value)) + " €")]) : _vm._e(), _vm._v(" "), (_vm.appraisal.total_construction_progress_pct < 100) ? _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.cost_method_unfinished_realestate_crn_value)) + " €")]) : _vm._e(), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.realestate_total_adopted_value)) + " €")])])])])])])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.warnings_text
      }
    }, [(_vm.currentLocale === 'ca') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Advertiments i observacions')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.warnings_text) + "\n\t\t\t\t\t\t\t")]) : (_vm.currentLocale === 'en') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Warnings and notes')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.warnings_text) + "\n\t\t\t\t\t\t\t")]) : _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Advertencias y observaciones')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.warnings_text) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "form-section"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Constraints')))]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onCreateNewConstraint($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus-circle",
        "text": _vm.new_constraint_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), (_vm.currentLocale === 'ca') ? _c('div', {}, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "constraint-table-main",
        "source": _vm.object_to_array(_vm.appraisal_constraints),
        "filterable": false,
        "striped": _vm.constraint_table_ca.striped,
        "editable": _vm.constraint_table_ca.editable,
        "line-numbers": _vm.constraint_table_ca.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "actions-constraints_ca",
        fn: function(cell) {
          return [_c('table', {
            staticClass: "actions-table"
          }, [_c('tr', [_c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.edit_text
            },
            on: {
              "click": function($event) {
                _vm.editConstraint(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "pencil",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)]), _vm._v(" "), _c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.delete_text
            },
            on: {
              "click": function($event) {
                _vm.deleteConstraint(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "trash-o",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)])])])]
        }
      }])
    }, [_vm._l((_vm.constraint_table_ca.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    }), _vm._v(" "), _c('datatable-column', {
      attrs: {
        "id": "actions-constraints_ca",
        "label": _vm.actions_text,
        "width": "160px",
        "sortable": false,
        "groupable": false
      }
    })], 2)], 1)])]) : (_vm.currentLocale === 'en') ? _c('div', {}, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "constraint-table-main",
        "source": _vm.object_to_array(_vm.appraisal_constraints),
        "filterable": false,
        "striped": _vm.constraint_table_en.striped,
        "editable": _vm.constraint_table_en.editable,
        "line-numbers": _vm.constraint_table_en.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "actions-constraints_en",
        fn: function(cell) {
          return [_c('table', {
            staticClass: "actions-table"
          }, [_c('tr', [_c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.edit_text
            },
            on: {
              "click": function($event) {
                _vm.editConstraint(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "pencil",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)]), _vm._v(" "), _c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.delete_text
            },
            on: {
              "click": function($event) {
                _vm.deleteConstraint(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "trash-o",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)])])])]
        }
      }])
    }, _vm._l((_vm.constraint_table_en.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    }))], 1)])]) : _c('div', {}, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "constraint-table-main",
        "source": _vm.object_to_array(_vm.appraisal_constraints),
        "filterable": false,
        "striped": _vm.constraint_table_es.striped,
        "editable": _vm.constraint_table_es.editable,
        "line-numbers": _vm.constraint_table_es.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "actions-constraints_es",
        fn: function(cell) {
          return [_c('table', {
            staticClass: "actions-table"
          }, [_c('tr', [_c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.edit_text
            },
            on: {
              "click": function($event) {
                _vm.editConstraint(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "pencil",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)]), _vm._v(" "), _c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.delete_text
            },
            on: {
              "click": function($event) {
                _vm.deleteConstraint(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "trash-o",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)])])])]
        }
      }])
    }, _vm._l((_vm.constraint_table_es.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    }))], 1)])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Warnings')))]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onCreateNewWarning($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus-circle",
        "text": _vm.new_warning_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), (_vm.currentLocale === 'ca') ? _c('div', {}, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "warning-table-main",
        "source": _vm.object_to_array(_vm.appraisal_warnings),
        "filterable": false,
        "striped": _vm.warning_table_ca.striped,
        "editable": _vm.warning_table_ca.editable,
        "line-numbers": _vm.warning_table_ca.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "actions-warnings_ca",
        fn: function(cell) {
          return [_c('table', {
            staticClass: "actions-table"
          }, [_c('tr', [_c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.edit_text
            },
            on: {
              "click": function($event) {
                _vm.editWarning(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "pencil",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)]), _vm._v(" "), _c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.delete_text
            },
            on: {
              "click": function($event) {
                _vm.deleteWarning(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "trash-o",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)])])])]
        }
      }])
    }, [_vm._l((_vm.warning_table_ca.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    }), _vm._v(" "), _c('datatable-column', {
      attrs: {
        "id": "actions-warnings_ca",
        "label": _vm.actions_text,
        "width": "160px",
        "sortable": false,
        "groupable": false
      }
    })], 2)], 1)])]) : (_vm.currentLocale === 'en') ? _c('div', {}, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "warning-table-main",
        "source": _vm.object_to_array(_vm.appraisal_warnings),
        "filterable": false,
        "striped": _vm.warning_table_en.striped,
        "editable": _vm.warning_table_en.editable,
        "line-numbers": _vm.warning_table_en.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "actions-warnings_em",
        fn: function(cell) {
          return [_c('table', {
            staticClass: "actions-table"
          }, [_c('tr', [_c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.edit_text
            },
            on: {
              "click": function($event) {
                _vm.editWarning(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "pencil",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)]), _vm._v(" "), _c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.delete_text
            },
            on: {
              "click": function($event) {
                _vm.deleteWarning(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "trash-o",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)])])])]
        }
      }])
    }, [_vm._l((_vm.warning_table_en.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    }), _vm._v(" "), _c('datatable-column', {
      attrs: {
        "id": "actions-warnings_en",
        "label": _vm.actions_text,
        "width": "160px",
        "sortable": false,
        "groupable": false
      }
    })], 2)], 1)])]) : _c('div', {}, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "warning-table-main",
        "source": _vm.object_to_array(_vm.appraisal_warnings),
        "filterable": false,
        "striped": _vm.warning_table_es.striped,
        "editable": _vm.warning_table_es.editable,
        "line-numbers": _vm.warning_table_es.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "actions-warnings_es",
        fn: function(cell) {
          return [_c('table', {
            staticClass: "actions-table"
          }, [_c('tr', [_c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.edit_text
            },
            on: {
              "click": function($event) {
                _vm.editWarning(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "pencil",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)]), _vm._v(" "), _c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.delete_text
            },
            on: {
              "click": function($event) {
                _vm.deleteWarning(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "trash-o",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)])])])]
        }
      }])
    }, [_vm._l((_vm.warning_table_es.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    }), _vm._v(" "), _c('datatable-column', {
      attrs: {
        "id": "actions-warnings_es",
        "label": _vm.actions_text,
        "width": "160px",
        "sortable": false,
        "groupable": false
      }
    })], 2)], 1)])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Notes')))]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onCreateNewNote($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus-circle",
        "text": _vm.new_note_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), (_vm.currentLocale === 'ca') ? _c('div', {}, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "note-table-main",
        "source": _vm.object_to_array(_vm.appraisal_notes),
        "filterable": false,
        "striped": _vm.note_table_ca.striped,
        "editable": _vm.note_table_ca.editable,
        "line-numbers": _vm.note_table_ca.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "actions-notes_es",
        fn: function(cell) {
          return [_c('table', {
            staticClass: "actions-table"
          }, [_c('tr', [_c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.edit_text
            },
            on: {
              "click": function($event) {
                _vm.editNote(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "pencil",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)]), _vm._v(" "), _c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.delete_text
            },
            on: {
              "click": function($event) {
                _vm.deleteNote(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "trash-o",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)])])])]
        }
      }])
    }, [_vm._l((_vm.note_table_ca.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    }), _vm._v(" "), _c('datatable-column', {
      attrs: {
        "id": "actions-notes_es",
        "label": _vm.actions_text,
        "width": "160px",
        "sortable": false,
        "groupable": false
      }
    })], 2)], 1)])]) : (_vm.currentLocale === 'en') ? _c('div', {}, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "note-table-main",
        "source": _vm.object_to_array(_vm.appraisal_notes),
        "filterable": false,
        "striped": _vm.note_table_en.striped,
        "editable": _vm.note_table_en.editable,
        "line-numbers": _vm.note_table_en.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "actions-notes_en",
        fn: function(cell) {
          return [_c('table', {
            staticClass: "actions-table"
          }, [_c('tr', [_c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.edit_text
            },
            on: {
              "click": function($event) {
                _vm.editNote(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "pencil",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)]), _vm._v(" "), _c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.delete_text
            },
            on: {
              "click": function($event) {
                _vm.deleteNote(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "trash-o",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)])])])]
        }
      }])
    }, [_vm._l((_vm.note_table_en.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    }), _vm._v(" "), _c('datatable-column', {
      attrs: {
        "id": "actions-notes_en",
        "label": _vm.actions_text,
        "width": "160px",
        "sortable": false,
        "groupable": false
      }
    })], 2)], 1)])]) : _c('div', {}, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "note-table-main",
        "source": _vm.object_to_array(_vm.appraisal_notes),
        "filterable": false,
        "striped": _vm.note_table_es.striped,
        "editable": _vm.note_table_es.editable,
        "line-numbers": _vm.note_table_es.lineNumbers
      }
    }, _vm._l((_vm.note_table_es.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    }))], 1)])])])])])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.checks_text
      }
    }, [(_vm.currentLocale === 'ca') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Comprovacions')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.checks_text) + "\n\t\t\t\t\t\t\t")]) : (_vm.currentLocale === 'en') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Checks')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.checks_text) + "\n\t\t\t\t\t\t\t")]) : _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Comprobaciones')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.checks_text))]), _vm._v(" "), _c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('div', {
      staticClass: "field-container"
    }, [_c('table', {
      staticStyle: {
        "width": "60em"
      }
    }, [_c('tr', [_c('th', [_c('h4', [_vm._v(_vm._s(_vm.$t('Checkings_realized')))])]), _vm._v(" "), _c('th', [_c('h4', [_vm._v(_vm._s(_vm.$t('Documents_used')))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('table', {
      staticStyle: {
        "width": "30em"
      }
    }, [_c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Cadastral_data')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.checks_cadastral_data),
        expression: "appraisal.checks_cadastral_data"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.checks_cadastral_data) ? _vm._i(_vm.appraisal.checks_cadastral_data, null) > -1 : (_vm.appraisal.checks_cadastral_data)
      },
      on: {
        "click": _vm.set_appraisal_checks_cadastral_data,
        "__c": function($event) {
          var $$a = _vm.appraisal.checks_cadastral_data,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.checks_cadastral_data = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.checks_cadastral_data = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.checks_cadastral_data = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Conservation_status')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.checks_conservation_status),
        expression: "appraisal.checks_conservation_status"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.checks_conservation_status) ? _vm._i(_vm.appraisal.checks_conservation_status, null) > -1 : (_vm.appraisal.checks_conservation_status)
      },
      on: {
        "click": _vm.set_appraisal_checks_conservation_status,
        "__c": function($event) {
          var $$a = _vm.appraisal.checks_conservation_status,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.checks_conservation_status = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.checks_conservation_status = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.checks_conservation_status = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Expropriation_procedure')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.checks_expropriation_procedure),
        expression: "appraisal.checks_expropriation_procedure"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.checks_expropriation_procedure) ? _vm._i(_vm.appraisal.checks_expropriation_procedure, null) > -1 : (_vm.appraisal.checks_expropriation_procedure)
      },
      on: {
        "click": _vm.set_appraisal_checks_expropriation_procedure,
        "__c": function($event) {
          var $$a = _vm.appraisal.checks_expropriation_procedure,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.checks_expropriation_procedure = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.checks_expropriation_procedure = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.checks_expropriation_procedure = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Expropriation_plan')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.checks_expropriation_plan),
        expression: "appraisal.checks_expropriation_plan"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.checks_expropriation_plan) ? _vm._i(_vm.appraisal.checks_expropriation_plan, null) > -1 : (_vm.appraisal.checks_expropriation_plan)
      },
      on: {
        "click": _vm.set_appraisal_checks_expropriation_plan,
        "__c": function($event) {
          var $$a = _vm.appraisal.checks_expropriation_plan,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.checks_expropriation_plan = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.checks_expropriation_plan = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.checks_expropriation_plan = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Expropriation_admin_ruling')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.checks_expropriation_admin_ruling),
        expression: "appraisal.checks_expropriation_admin_ruling"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.checks_expropriation_admin_ruling) ? _vm._i(_vm.appraisal.checks_expropriation_admin_ruling, null) > -1 : (_vm.appraisal.checks_expropriation_admin_ruling)
      },
      on: {
        "click": _vm.set_appraisal_checks_expropriation_admin_ruling,
        "__c": function($event) {
          var $$a = _vm.appraisal.checks_expropriation_admin_ruling,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.checks_expropriation_admin_ruling = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.checks_expropriation_admin_ruling = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.checks_expropriation_admin_ruling = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Expropriation_file')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.checks_expropriation_file),
        expression: "appraisal.checks_expropriation_file"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.checks_expropriation_file) ? _vm._i(_vm.appraisal.checks_expropriation_file, null) > -1 : (_vm.appraisal.checks_expropriation_file)
      },
      on: {
        "click": _vm.set_appraisal_checks_expropriation_file,
        "__c": function($event) {
          var $$a = _vm.appraisal.checks_expropriation_file,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.checks_expropriation_file = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.checks_expropriation_file = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.checks_expropriation_file = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Interior_visit')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.checks_interior_visit),
        expression: "appraisal.checks_interior_visit"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.checks_interior_visit) ? _vm._i(_vm.appraisal.checks_interior_visit, null) > -1 : (_vm.appraisal.checks_interior_visit)
      },
      on: {
        "click": _vm.set_appraisal_checks_interior_visit,
        "__c": function($event) {
          var $$a = _vm.appraisal.checks_interior_visit,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.checks_interior_visit = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.checks_interior_visit = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.checks_interior_visit = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Occupancy')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.checks_occupancy),
        expression: "appraisal.checks_occupancy"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.checks_occupancy) ? _vm._i(_vm.appraisal.checks_occupancy, null) > -1 : (_vm.appraisal.checks_occupancy)
      },
      on: {
        "click": _vm.set_appraisal_checks_occupancy,
        "__c": function($event) {
          var $$a = _vm.appraisal.checks_occupancy,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.checks_occupancy = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.checks_occupancy = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.checks_occupancy = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Registry_data')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.checks_registry_data),
        expression: "appraisal.checks_registry_data"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.checks_registry_data) ? _vm._i(_vm.appraisal.checks_registry_data, null) > -1 : (_vm.appraisal.checks_registry_data)
      },
      on: {
        "click": _vm.set_appraisal_checks_registry_data,
        "__c": function($event) {
          var $$a = _vm.appraisal.checks_registry_data,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.checks_registry_data = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.checks_registry_data = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.checks_registry_data = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Servitudes')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.checks_servitudes),
        expression: "appraisal.checks_servitudes"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.checks_servitudes) ? _vm._i(_vm.appraisal.checks_servitudes, null) > -1 : (_vm.appraisal.checks_servitudes)
      },
      on: {
        "click": _vm.set_appraisal_checks_servitudes,
        "__c": function($event) {
          var $$a = _vm.appraisal.checks_servitudes,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.checks_servitudes = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.checks_servitudes = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.checks_servitudes = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Public_protection_regime')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.checks_subsidy_status),
        expression: "appraisal.checks_subsidy_status"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.checks_subsidy_status) ? _vm._i(_vm.appraisal.checks_subsidy_status, null) > -1 : (_vm.appraisal.checks_subsidy_status)
      },
      on: {
        "click": _vm.set_appraisal_checks_subsidy_status,
        "__c": function($event) {
          var $$a = _vm.appraisal.checks_subsidy_status,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.checks_subsidy_status = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.checks_subsidy_status = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.checks_subsidy_status = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Urban_parameters_suitability')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.checks_urban_planning),
        expression: "appraisal.checks_urban_planning"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.checks_urban_planning) ? _vm._i(_vm.appraisal.checks_urban_planning, null) > -1 : (_vm.appraisal.checks_urban_planning)
      },
      on: {
        "click": _vm.set_appraisal_checks_urban_planning,
        "__c": function($event) {
          var $$a = _vm.appraisal.checks_urban_planning,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.checks_urban_planning = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.checks_urban_planning = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.checks_urban_planning = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Other')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.checks_other),
        expression: "appraisal.checks_other"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.checks_other)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.checks_other = $event.target.value
        }, _vm.set_appraisal_checks_other]
      }
    })])])])])]), _vm._v(" "), _c('td', [_c('table', {
      staticStyle: {
        "width": "30em"
      }
    }, [_c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Approved_project_by_professional_association')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.docs_approved_project),
        expression: "appraisal.docs_approved_project"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.docs_approved_project) ? _vm._i(_vm.appraisal.docs_approved_project, null) > -1 : (_vm.appraisal.docs_approved_project)
      },
      on: {
        "click": _vm.set_appraisal_docs_approved_project,
        "__c": function($event) {
          var $$a = _vm.appraisal.docs_approved_project,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.docs_approved_project = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.docs_approved_project = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.docs_approved_project = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Cadastral_documents')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.docs_cadastral_data),
        expression: "appraisal.docs_cadastral_data"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.docs_cadastral_data) ? _vm._i(_vm.appraisal.docs_cadastral_data, null) > -1 : (_vm.appraisal.docs_cadastral_data)
      },
      on: {
        "click": _vm.set_appraisal_docs_cadastral_data,
        "__c": function($event) {
          var $$a = _vm.appraisal.docs_cadastral_data,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.docs_cadastral_data = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.docs_cadastral_data = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.docs_cadastral_data = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Construction_license')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.docs_construction_license),
        expression: "appraisal.docs_construction_license"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.docs_construction_license) ? _vm._i(_vm.appraisal.docs_construction_license, null) > -1 : (_vm.appraisal.docs_construction_license)
      },
      on: {
        "click": _vm.set_appraisal_docs_construction_license,
        "__c": function($event) {
          var $$a = _vm.appraisal.docs_construction_license,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.docs_construction_license = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.docs_construction_license = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.docs_construction_license = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Construction_last_certificate')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.docs_construction_last_certificate),
        expression: "appraisal.docs_construction_last_certificate"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.docs_construction_last_certificate) ? _vm._i(_vm.appraisal.docs_construction_last_certificate, null) > -1 : (_vm.appraisal.docs_construction_last_certificate)
      },
      on: {
        "click": _vm.set_appraisal_docs_construction_last_certificate,
        "__c": function($event) {
          var $$a = _vm.appraisal.docs_construction_last_certificate,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.docs_construction_last_certificate = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.docs_construction_last_certificate = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.docs_construction_last_certificate = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Construction_contract')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.docs_construction_contract),
        expression: "appraisal.docs_construction_contract"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.docs_construction_contract) ? _vm._i(_vm.appraisal.docs_construction_contract, null) > -1 : (_vm.appraisal.docs_construction_contract)
      },
      on: {
        "click": _vm.set_appraisal_docs_construction_contract,
        "__c": function($event) {
          var $$a = _vm.appraisal.docs_construction_contract,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.docs_construction_contract = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.docs_construction_contract = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.docs_construction_contract = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Occupancy_status')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.docs_occupancy_status),
        expression: "appraisal.docs_occupancy_status"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.docs_occupancy_status) ? _vm._i(_vm.appraisal.docs_occupancy_status, null) > -1 : (_vm.appraisal.docs_occupancy_status)
      },
      on: {
        "click": _vm.set_appraisal_docs_occupancy_status,
        "__c": function($event) {
          var $$a = _vm.appraisal.docs_occupancy_status,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.docs_occupancy_status = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.docs_occupancy_status = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.docs_occupancy_status = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Photographic_report')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.docs_photographic_report),
        expression: "appraisal.docs_photographic_report"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.docs_photographic_report) ? _vm._i(_vm.appraisal.docs_photographic_report, null) > -1 : (_vm.appraisal.docs_photographic_report)
      },
      on: {
        "click": _vm.set_appraisal_docs_photographic_report,
        "__c": function($event) {
          var $$a = _vm.appraisal.docs_photographic_report,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.docs_photographic_report = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.docs_photographic_report = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.docs_photographic_report = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Property_sketch')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.docs_property_sketch),
        expression: "appraisal.docs_property_sketch"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.docs_property_sketch) ? _vm._i(_vm.appraisal.docs_property_sketch, null) > -1 : (_vm.appraisal.docs_property_sketch)
      },
      on: {
        "click": _vm.set_appraisal_docs_property_sketch,
        "__c": function($event) {
          var $$a = _vm.appraisal.docs_property_sketch,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.docs_property_sketch = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.docs_property_sketch = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.docs_property_sketch = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Property_titles')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.docs_property_titles),
        expression: "appraisal.docs_property_titles"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.docs_property_titles) ? _vm._i(_vm.appraisal.docs_property_titles, null) > -1 : (_vm.appraisal.docs_property_titles)
      },
      on: {
        "click": _vm.set_appraisal_docs_property_titles,
        "__c": function($event) {
          var $$a = _vm.appraisal.docs_property_titles,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.docs_property_titles = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.docs_property_titles = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.docs_property_titles = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Situation_plan')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.docs_situation_plan),
        expression: "appraisal.docs_situation_plan"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.docs_situation_plan) ? _vm._i(_vm.appraisal.docs_situation_plan, null) > -1 : (_vm.appraisal.docs_situation_plan)
      },
      on: {
        "click": _vm.set_appraisal_docs_situation_plan,
        "__c": function($event) {
          var $$a = _vm.appraisal.docs_situation_plan,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.docs_situation_plan = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.docs_situation_plan = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.docs_situation_plan = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Subsidy_status')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.docs_subsidy_status),
        expression: "appraisal.docs_subsidy_status"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.docs_subsidy_status) ? _vm._i(_vm.appraisal.docs_subsidy_status, null) > -1 : (_vm.appraisal.docs_subsidy_status)
      },
      on: {
        "click": _vm.set_appraisal_docs_subsidy_status,
        "__c": function($event) {
          var $$a = _vm.appraisal.docs_subsidy_status,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.docs_subsidy_status = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.docs_subsidy_status = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.docs_subsidy_status = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Ten_year_insurance')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.docs_tenyear_insurance),
        expression: "appraisal.docs_tenyear_insurance"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.docs_tenyear_insurance) ? _vm._i(_vm.appraisal.docs_tenyear_insurance, null) > -1 : (_vm.appraisal.docs_tenyear_insurance)
      },
      on: {
        "click": _vm.set_appraisal_docs_tenyear_insurance,
        "__c": function($event) {
          var $$a = _vm.appraisal.docs_tenyear_insurance,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.docs_tenyear_insurance = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.docs_tenyear_insurance = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.docs_tenyear_insurance = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Urban_plan')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.docs_urban_plan),
        expression: "appraisal.docs_urban_plan"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.docs_urban_plan) ? _vm._i(_vm.appraisal.docs_urban_plan, null) > -1 : (_vm.appraisal.docs_urban_plan)
      },
      on: {
        "click": _vm.set_appraisal_docs_urban_plan,
        "__c": function($event) {
          var $$a = _vm.appraisal.docs_urban_plan,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.docs_urban_plan = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.docs_urban_plan = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.docs_urban_plan = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Other')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.docs_other),
        expression: "appraisal.docs_other"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.docs_other)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.docs_other = $event.target.value
        }, _vm.set_appraisal_docs_other]
      }
    })])])])])])])])])])])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.annexes_text
      }
    }, [(_vm.currentLocale === 'ca') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Annexes')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.annexes_text) + "\n\t\t\t\t\t\t\t")]) : (_vm.currentLocale === 'en') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Annexes')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.annexes_text) + "\n\t\t\t\t\t\t\t")]) : _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Anexos')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.annexes_text) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticStyle: {
        "background": "lightyellow",
        "padding": "1rem"
      }
    }, [_c('span', [_c('strong', [_vm._v("Nota:")]), _vm._v(" Les imatges han de ser carregades en format PNG o JPG. Altres formats no funcionaran correctament a l'hora d'imprimir el PDF de l'informe.")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
      staticClass: "form-section"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Photographs')))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "background-color": "#fafafc",
        "padding-left": "2rem",
        "padding-top": "0.5rem",
        "padding-bottom": "1rem",
        "margin-top": "1rem",
        "margin-bottom": "1rem",
        "margin-right": "1rem"
      }
    }, [_c('h4', [_vm._v(_vm._s(_vm.$t('Upload_files')))]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": "files",
        "name": "files[]",
        "accept": "image/*",
        "multiple": ""
      },
      on: {
        "change": _vm.uploadPhotographFiles
      }
    })]), _vm._v(" "), _c('div', {}, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "constraint-table-main",
        "source": _vm.object_to_array(_vm.appraisal_photographs),
        "filterable": false,
        "striped": _vm.photograph_table_ca.striped,
        "editable": _vm.photograph_table_ca.editable,
        "line-numbers": _vm.photograph_table_ca.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "actions-photographs",
        fn: function(cell) {
          return [_c('table', {
            staticClass: "actions-table"
          }, [_c('tr', [_c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.edit_text
            },
            on: {
              "click": function($event) {
                _vm.editPhotograph(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "pencil",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)]), _vm._v(" "), _c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.delete_text
            },
            on: {
              "click": function($event) {
                _vm.deletePhotograph(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "trash-o",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)])])])]
        }
      }, {
        key: "cover-checkbox",
        fn: function(cell) {
          return [_c('div', [_c('checkbox', {
            attrs: {
              "id": cell.row.id,
              "editable": _vm.editabletrue
            },
            on: {
              "toggle_flag": function($event) {
                _vm.set_appraisal_cover_photo(cell.row['is_cover_photo'], cell.row)
              }
            },
            model: {
              value: (cell.row['is_cover_photo']),
              callback: function($$v) {
                var $$exp = cell.row,
                  $$idx = 'is_cover_photo';
                if (!Array.isArray($$exp)) {
                  cell.row['is_cover_photo'] = $$v
                } else {
                  $$exp.splice($$idx, 1, $$v)
                }
              },
              expression: "cell.row['is_cover_photo']"
            }
          })], 1)]
        }
      }, {
        key: "thumbnail-photographs",
        fn: function(cell) {
          return [_c('div', [_c('img', {
            attrs: {
              "src": cell.row['thumb_url'],
              "width": "200px",
              "height": "auto"
            }
          })])]
        }
      }])
    }, [_vm._l((_vm.photograph_table_ca.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    }), _vm._v(" "), _c('datatable-column', {
      attrs: {
        "id": "thumbnail-photographs",
        "label": "Thumbnail",
        "width": "240px",
        "sortable": false,
        "groupable": false
      }
    }), _vm._v(" "), _c('datatable-column', {
      attrs: {
        "id": "cover-checkbox",
        "label": _vm.cover_text,
        "width": "80px",
        "sortable": false,
        "groupable": false
      }
    }), _vm._v(" "), _c('datatable-column', {
      attrs: {
        "id": "actions-photographs",
        "label": _vm.actions_text,
        "width": "160px",
        "sortable": false,
        "groupable": false
      }
    })], 2)], 1)])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Registry_Documents')))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "background-color": "#fafafc",
        "padding-left": "2rem",
        "padding-top": "0.5rem",
        "padding-bottom": "1rem",
        "margin-top": "1rem",
        "margin-bottom": "1rem",
        "margin-right": "1rem"
      }
    }, [_c('h4', [_vm._v(_vm._s(_vm.$t('Upload_files')))]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": "files",
        "name": "files[]",
        "accept": "image/*",
        "multiple": ""
      },
      on: {
        "change": _vm.uploadRegistryAnnexFiles
      }
    })]), _vm._v(" "), _c('div', {}, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "constraint-table-main",
        "source": _vm.object_to_array(_vm.appraisal_registryannexes),
        "filterable": false,
        "striped": _vm.registryannex_table_ca.striped,
        "editable": _vm.registryannex_table_ca.editable,
        "line-numbers": _vm.registryannex_table_ca.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "actions-registryannexes",
        fn: function(cell) {
          return [_c('table', {
            staticClass: "actions-table"
          }, [_c('tr', [_c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.edit_text
            },
            on: {
              "click": function($event) {
                _vm.editRegistryAnnex(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "pencil",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)]), _vm._v(" "), _c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.delete_text
            },
            on: {
              "click": function($event) {
                _vm.deleteRegistryAnnex(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "trash-o",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)])])])]
        }
      }, {
        key: "thumbnail-photographs",
        fn: function(cell) {
          return [_c('div', [_c('img', {
            attrs: {
              "src": cell.row['thumb_url'],
              "width": "200px",
              "height": "auto"
            }
          })])]
        }
      }])
    }, [_vm._l((_vm.registryannex_table_ca.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    }), _vm._v(" "), _c('datatable-column', {
      attrs: {
        "id": "thumbnail-photographs",
        "label": "Thumbnail",
        "width": "240px",
        "sortable": false,
        "groupable": false
      }
    }), _vm._v(" "), _c('datatable-column', {
      attrs: {
        "id": "actions-registryannexes",
        "label": _vm.actions_text,
        "width": "160px",
        "sortable": false,
        "groupable": false
      }
    })], 2)], 1)])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Cadastral_Documents')))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "background-color": "#fafafc",
        "padding-left": "2rem",
        "padding-top": "0.5rem",
        "padding-bottom": "1rem",
        "margin-top": "1rem",
        "margin-bottom": "1rem",
        "margin-right": "1rem"
      }
    }, [_c('h4', [_vm._v(_vm._s(_vm.$t('Upload_files')))]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": "files",
        "name": "files[]",
        "accept": "image/*",
        "multiple": ""
      },
      on: {
        "change": _vm.uploadCadasterAnnexFiles
      }
    })]), _vm._v(" "), _c('div', {}, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "constraint-table-main",
        "source": _vm.object_to_array(_vm.appraisal_cadasterannexes),
        "filterable": false,
        "striped": _vm.cadasterannex_table_ca.striped,
        "editable": _vm.cadasterannex_table_ca.editable,
        "line-numbers": _vm.cadasterannex_table_ca.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "actions-cadasterannexes",
        fn: function(cell) {
          return [_c('table', {
            staticClass: "actions-table"
          }, [_c('tr', [_c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.edit_text
            },
            on: {
              "click": function($event) {
                _vm.editCadasterAnnex(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "pencil",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)]), _vm._v(" "), _c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.delete_text
            },
            on: {
              "click": function($event) {
                _vm.deleteCadasterAnnex(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "trash-o",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)])])])]
        }
      }, {
        key: "thumbnail-photographs",
        fn: function(cell) {
          return [_c('div', [_c('img', {
            attrs: {
              "src": cell.row['thumb_url'],
              "width": "200px",
              "height": "auto"
            }
          })])]
        }
      }])
    }, [_vm._l((_vm.cadasterannex_table_ca.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    }), _vm._v(" "), _c('datatable-column', {
      attrs: {
        "id": "thumbnail-photographs",
        "label": "Thumbnail",
        "width": "240px",
        "sortable": false,
        "groupable": false
      }
    }), _vm._v(" "), _c('datatable-column', {
      attrs: {
        "id": "actions-cadasterannexes",
        "label": _vm.actions_text,
        "width": "160px",
        "sortable": false,
        "groupable": false
      }
    })], 2)], 1)])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Urban_Planning_Documents')))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "background-color": "#fafafc",
        "padding-left": "2rem",
        "padding-top": "0.5rem",
        "padding-bottom": "1rem",
        "margin-top": "1rem",
        "margin-bottom": "1rem",
        "margin-right": "1rem"
      }
    }, [_c('h4', [_vm._v(_vm._s(_vm.$t('Upload_files')))]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": "files",
        "name": "files[]",
        "accept": "image/*",
        "multiple": ""
      },
      on: {
        "change": _vm.uploadUrbanAnnexFiles
      }
    })]), _vm._v(" "), _c('div', {}, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "constraint-table-main",
        "source": _vm.object_to_array(_vm.appraisal_urbanannexes),
        "filterable": false,
        "striped": _vm.urbanannex_table_ca.striped,
        "editable": _vm.urbanannex_table_ca.editable,
        "line-numbers": _vm.urbanannex_table_ca.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "actions-urbanannexes",
        fn: function(cell) {
          return [_c('table', {
            staticClass: "actions-table"
          }, [_c('tr', [_c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.edit_text
            },
            on: {
              "click": function($event) {
                _vm.editUrbanAnnex(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "pencil",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)]), _vm._v(" "), _c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.delete_text
            },
            on: {
              "click": function($event) {
                _vm.deleteUrbanAnnex(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "trash-o",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)])])])]
        }
      }, {
        key: "thumbnail-photographs",
        fn: function(cell) {
          return [_c('div', [_c('img', {
            attrs: {
              "src": cell.row['thumb_url'],
              "width": "200px",
              "height": "auto"
            }
          })])]
        }
      }])
    }, [_vm._l((_vm.urbanannex_table_ca.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    }), _vm._v(" "), _c('datatable-column', {
      attrs: {
        "id": "thumbnail-photographs",
        "label": "Thumbnail",
        "width": "240px",
        "sortable": false,
        "groupable": false
      }
    }), _vm._v(" "), _c('datatable-column', {
      attrs: {
        "id": "actions-urbanannexes",
        "label": _vm.actions_text,
        "width": "160px",
        "sortable": false,
        "groupable": false
      }
    })], 2)], 1)])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Plans')) + " " + _vm._s(_vm.$t('and')) + " " + _vm._s(_vm.$t('Sketches')))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "background-color": "#fafafc",
        "padding-left": "2rem",
        "padding-top": "0.5rem",
        "padding-bottom": "1rem",
        "margin-top": "1rem",
        "margin-bottom": "1rem",
        "margin-right": "1rem"
      }
    }, [_c('h4', [_vm._v(_vm._s(_vm.$t('Upload_files')))]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": "files",
        "name": "files[]",
        "accept": "image/*",
        "multiple": ""
      },
      on: {
        "change": _vm.uploadPlanAnnexFiles
      }
    })]), _vm._v(" "), _c('div', {}, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "constraint-table-main",
        "source": _vm.object_to_array(_vm.appraisal_planannexes),
        "filterable": false,
        "striped": _vm.planannex_table_ca.striped,
        "editable": _vm.planannex_table_ca.editable,
        "line-numbers": _vm.planannex_table_ca.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "actions-planannexes",
        fn: function(cell) {
          return [_c('table', {
            staticClass: "actions-table"
          }, [_c('tr', [_c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.edit_text
            },
            on: {
              "click": function($event) {
                _vm.editPlanAnnex(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "pencil",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)]), _vm._v(" "), _c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.delete_text
            },
            on: {
              "click": function($event) {
                _vm.deletePlanAnnex(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "trash-o",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)])])])]
        }
      }, {
        key: "thumbnail-photographs",
        fn: function(cell) {
          return [_c('div', [_c('img', {
            attrs: {
              "src": cell.row['thumb_url'],
              "width": "200px",
              "height": "auto"
            }
          })])]
        }
      }])
    }, [_vm._l((_vm.planannex_table_ca.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    }), _vm._v(" "), _c('datatable-column', {
      attrs: {
        "id": "thumbnail-photographs",
        "label": "Thumbnail",
        "width": "240px",
        "sortable": false,
        "groupable": false
      }
    }), _vm._v(" "), _c('datatable-column', {
      attrs: {
        "id": "actions-planannexes",
        "label": _vm.actions_text,
        "width": "160px",
        "sortable": false,
        "groupable": false
      }
    })], 2)], 1)])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Cession_Documents')) + " " + _vm._s(_vm.$t('and')) + " " + _vm._s(_vm.$t('Contracts')))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "background-color": "#fafafc",
        "padding-left": "2rem",
        "padding-top": "0.5rem",
        "padding-bottom": "1rem",
        "margin-top": "1rem",
        "margin-bottom": "1rem",
        "margin-right": "1rem"
      }
    }, [_c('h4', [_vm._v(_vm._s(_vm.$t('Upload_files')))]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": "files",
        "name": "files[]",
        "accept": "image/*",
        "multiple": ""
      },
      on: {
        "change": _vm.uploadCessionAnnexFiles
      }
    })]), _vm._v(" "), _c('div', {}, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "constraint-table-main",
        "source": _vm.object_to_array(_vm.appraisal_cessionannexes),
        "filterable": false,
        "striped": _vm.cessionannex_table_ca.striped,
        "editable": _vm.cessionannex_table_ca.editable,
        "line-numbers": _vm.cessionannex_table_ca.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "actions-cessionannexes",
        fn: function(cell) {
          return [_c('table', {
            staticClass: "actions-table"
          }, [_c('tr', [_c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.edit_text
            },
            on: {
              "click": function($event) {
                _vm.editCessionAnnex(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "pencil",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)]), _vm._v(" "), _c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.delete_text
            },
            on: {
              "click": function($event) {
                _vm.deleteCessionAnnex(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "trash-o",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)])])])]
        }
      }, {
        key: "thumbnail-photographs",
        fn: function(cell) {
          return [_c('div', [_c('img', {
            attrs: {
              "src": cell.row['thumb_url'],
              "width": "200px",
              "height": "auto"
            }
          })])]
        }
      }])
    }, [_vm._l((_vm.cessionannex_table_ca.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    }), _vm._v(" "), _c('datatable-column', {
      attrs: {
        "id": "thumbnail-photographs",
        "label": "Thumbnail",
        "width": "240px",
        "sortable": false,
        "groupable": false
      }
    }), _vm._v(" "), _c('datatable-column', {
      attrs: {
        "id": "actions-cessionannexes",
        "label": _vm.actions_text,
        "width": "160px",
        "sortable": false,
        "groupable": false
      }
    })], 2)], 1)])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Other_Documents')))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "background-color": "#fafafc",
        "padding-left": "2rem",
        "padding-top": "0.5rem",
        "padding-bottom": "1rem",
        "margin-top": "1rem",
        "margin-bottom": "1rem",
        "margin-right": "1rem"
      }
    }, [_c('h4', [_vm._v(_vm._s(_vm.$t('Upload_files')))]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": "files",
        "name": "files[]",
        "accept": "image/*",
        "multiple": ""
      },
      on: {
        "change": _vm.uploadOtherAnnexFiles
      }
    })]), _vm._v(" "), _c('div', {}, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "constraint-table-main",
        "source": _vm.object_to_array(_vm.appraisal_otherannexes),
        "filterable": false,
        "striped": _vm.otherannex_table_ca.striped,
        "editable": _vm.otherannex_table_ca.editable,
        "line-numbers": _vm.otherannex_table_ca.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "actions-otherannexes",
        fn: function(cell) {
          return [_c('table', {
            staticClass: "actions-table"
          }, [_c('tr', [_c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.edit_text
            },
            on: {
              "click": function($event) {
                _vm.editOtherAnnex(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "pencil",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)]), _vm._v(" "), _c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.delete_text
            },
            on: {
              "click": function($event) {
                _vm.deleteOtherAnnex(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "trash-o",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)])])])]
        }
      }, {
        key: "thumbnail-photographs",
        fn: function(cell) {
          return [_c('div', [_c('img', {
            attrs: {
              "src": cell.row['thumb_url'],
              "width": "200px",
              "height": "auto"
            }
          })])]
        }
      }])
    }, [_vm._l((_vm.otherannex_table_ca.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    }), _vm._v(" "), _c('datatable-column', {
      attrs: {
        "id": "thumbnail-photographs",
        "label": "Thumbnail",
        "width": "240px",
        "sortable": false,
        "groupable": false
      }
    }), _vm._v(" "), _c('datatable-column', {
      attrs: {
        "id": "actions-otherannexes",
        "label": _vm.actions_text,
        "width": "160px",
        "sortable": false,
        "groupable": false
      }
    })], 2)], 1)])])])])])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.metadata_text
      }
    }, [(_vm.currentLocale === 'ca') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Metadades')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.metadata_text) + "\n\t\t\t\t\t\t\t")]) : (_vm.currentLocale === 'en') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Metadatos')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.metadata_text) + "\n\t\t\t\t\t\t\t")]) : _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Metadata')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.metadata_text) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Description')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Appraisal_description')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.description),
        expression: "appraisal.description"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.description)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.description = $event.target.value
        }, _vm.set_appraisal_description]
      }
    })])])])])])])])], 1), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoUp($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "level-up",
        "text": _vm.goup_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentAppraisal({
            go_up: false
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentAppraisal({
            go_up: true
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_and_go_up_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), (_vm.appraisal.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e()], 1)], 1)]
  ], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-69c3bc0c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/app/appraisals/AppraisalEditor.vue
// module id = 2160
// module chunks = 0